import { EventEmitter, Injectable } from '@angular/core';
import * as L from 'leaflet';
import 'leaflet-draw';
import { Store } from '@ngrx/store';
import * as VehicleActions from '../store/iotAssets/iotAsset.actions';
import { selectMappingConfig } from '../store/iotAssets/iotAsset.selector';
import { IotAssetState } from '../store/iotAssets/iotAsset.reducer';

import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { take, switchMap, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from './data.service';

import { MapContainerService } from './mapContainer.service';
import { exportPDFService } from './exportPDF.service'
import { UtilsService } from './utils.service';
import * as moment from 'moment';
// import { ActiaJourneyService } from './actia-journey.service';
// import { HistorialJourneyContainerService } from './historicalJourneyContainer.service';
import { IotAsset } from '../models/iotAssetsModel.data';
import { IotAssetsService } from './iotAssets.service';
import { LoggerService } from './logger.service';
import { ApiService } from './api.service';
import { CatalogService } from './catalog.service';
import { CatalogResponseV2, MergedField } from '../models/catalog.model';
import { getApplySelectedCustomer } from '../store/selectors';
import { AppStateInterface } from 'src/app/appState.interface';
import { GEOFENCING_BY_CUSTOMER_ENDPOINT, MAP_FIELD_SCOPES } from '../config/config.constants';
import { extractNameFromFieldConfigKey, buildFieldConfigKey } from '../models/asset-config.model';
import * as _ from 'lodash';

const attribution =
  `© ${new Date().getFullYear()} Actia Italia - <a href="https://actiafleet.com/actia-italia/"> </a>`;
@Injectable({
  providedIn: 'root'
})
export class ActiaMapService {
  private map: L.Map | undefined;
  private markersMap: { [key: string]: L.Marker } = {};
  private markerClusterGroup: L.MarkerClusterGroup | undefined;
  private statusControlElement: HTMLElement | null = null;

  // Drawing properties
  private drawControl: L.Control.Draw | undefined;
  private editableLayers: L.FeatureGroup = new L.FeatureGroup();

  // Drawing events
  public onPolygonCreated: EventEmitter<any> = new EventEmitter();
  public onShapeEdited: EventEmitter<any> = new EventEmitter();
  public onShapeDeleted: EventEmitter<any> = new EventEmitter();
  public _options: any;
  public tileUrl: any;
  public language: string;
  public lblLoading: string;
  public lblRefreshing: string;
  incidentMarkers: any[] = [];
  private tempMarker: L.Marker | null = null;
  public ui: any; // Add this line to declare the ui property
  lastCenterLatLng: { lat: number; lng: number } | null = null;
  trafficAbortController: any;
  trafficMarkers: any[] = []; // Array to hold traffic flow markers
  activateRepo: boolean = false;
  public weatherActive: boolean = false;
  public fieldLabelsVisible: boolean = false;
  private assetMappingConfig: any = null;
  private mergedFieldsMap: { [key: string]: MergedField } = {};
  private catalogVisibleFieldNames = new Set<string>();

  // Geofence properties
  public polygonsGeofence: any[] = [];
  public geofenceActive: boolean = false;
  public geofencePanelVisible: boolean = false;
  public visibleGeofences: any[] = [];
  public selectedCustomerUidSelector$: any = null;

  // Proprietà per il meteo
  public weatherApiKey: string = '';
  public weatherApiBaseUrl: string = '';
  public weatherLayerOpts: any;
  public selectedWeatherLayers: any[] = [];
  public weatherLayerEndpoint: any;
  public weatherTsUrlEndpoint: any;
  public weatherOpacityUrl: any;
  public globalLayerId: number = 0;
  public scaleWrapper: any;
  public choroplethScale: any;
  public currentLayerName: any;

  // Proprietà per ottimizzazione traffico
  private trafficUpdateInterval: any = null;
  private lastTrafficUpdate: number = 0;
  private readonly TRAFFIC_UPDATE_INTERVAL = 30000; // 30 secondi
  private readonly MAX_TRAFFIC_MARKERS = 50; // Limite massimo marker traffico
  private readonly MAX_INCIDENT_MARKERS = 20; // Limite massimo marker incidenti

  openSearchRoute = new EventEmitter<boolean>();
  tutorialActive = new EventEmitter<boolean>();
  // Aggiungi queste proprietà per gestire i marker temporanei di partenza/arrivo
  private _routeStartMarker: any = null;
  private _routeEndMarker: any = null;
  public onMapRightClick: EventEmitter<{
    type: 'start' | 'end';
    latlng: L.LatLng;
  }> = new EventEmitter();
  private prohibitionsLayer: L.TileLayer | null = null;
  public prohibitionsActive: boolean = false;

  // Geofence events
  public changeGeofence = new Subject<boolean>();
  public changeGeofenceLayer = new Subject<any>();
  public geofencePanelToggle = new Subject<boolean>();

  private hasRoutePoints(): boolean {
    return !!this._routeStartMarker || !!this._routeEndMarker;
  }


  //GESTION SCIA VEICOLO SELEZIONATO
  private vehicleTrails: Map<string, {
    positions: L.LatLng[],
    polyline: L.Polyline | null
  }> = new Map();
  private readonly TRAIL_MAX_POINTS = 20; // Numero massimo di punti nella scia



  // BehaviorSubject per i punti di partenza e arrivo
  private selectedStartAddressSubject = new BehaviorSubject<{
    lat: number,
    lng: number,
    label: string
  } | null>(null);

  // Esponi l'observable
  public selectedStartAddress$ = this.selectedStartAddressSubject.asObservable();

  private selectedEndAddressSubject = new BehaviorSubject<{
    lat: number,
    lng: number,
    label: string
  } | null>(null);

  // Esponi l'observable
  public selectedEndAddress$ = this.selectedEndAddressSubject.asObservable();

  // Observable pubblici

  // Proprietà per gestire i poligoni dei fields agricoli
  public polygonsFields: any[] = [];
  public polygonGroupLayer: L.FeatureGroup | undefined;
  // Mappa per gestire i fields agricoli persistenti (simile ai marker)
  private fieldsMap: { [fieldId: string]: L.Polygon } = {};
  private fieldsLayerGroup: L.LayerGroup | undefined;

  constructor(
    private store: Store<AppStateInterface & { iotAssets: IotAssetState }>,
    private datePipe: DatePipe,
    private translateService: TranslateService,
    private dataService: DataService,
    private vehicleService: IotAssetsService,
    private mapContainerService: MapContainerService,
    private exportPDFService: exportPDFService,
    private utilsService: UtilsService,
    // private journeyService: ActiaJourneyService,
    private utlService: UtilsService,
    //private HJourneyService: HistorialJourneyContainerService
    private logger: LoggerService,
    private apiService: ApiService,
    private catalogService: CatalogService
  ) {
    // this.language = this.dataService.getLanguage();
    // console.log('ActiaMapService language:', this.language);

    const currentLanguage = this.dataService.getLanguage();
   // console.log('Lingua da dataService:', currentLanguage);

    this.translateService.setDefaultLang(currentLanguage);
    this.translateService.use(currentLanguage); // Forza l'uso della lingua

   // console.log('Lingua dopo setDefaultLang:', this.translateService.currentLang);

    this.lblLoading = this.translateService.instant('mapPage.loading');
    this.lblRefreshing = this.translateService.instant('mapPage.refreshing');

    // Sottoscrizione alla configurazione dei campi
    this.store.select(selectMappingConfig).subscribe(config => {
      // console.log('🔧 STORE CONFIG CHANGE - Nuova configurazione ricevuta:', {
      //   hasConfig: !!config,
      //   fieldsCount: config?.fields ? Object.keys(config.fields).length : 0,
      //   timestamp: new Date().toISOString()
      // });
      const previousConfig = this.assetMappingConfig;
      this.assetMappingConfig = config;
      // console.log('🔧 STORE CONFIG CHANGE - Configurazione precedente:', {
      //   hasPrevious: !!previousConfig,
      //   prevFieldsCount: previousConfig?.fields ? Object.keys(previousConfig.fields).length : 0
      // });

      // FORZA sempre l'aggiornamento dei popup quando arriva una nuova configurazione
      // console.log('🔄 CONFIG CHANGE CHECK:', {
      //   hasPreviousConfig: !!previousConfig,
      //   hasNewConfig: !!config,
      //   markerCount: this.markersMap ? Object.keys(this.markersMap).length : 0
      // });

      if (config && this.markersMap && Object.keys(this.markersMap).length > 0) {
        this.logger.info('actia-map', 'POPUP UPDATE - FORZANDO aggiornamento popup dei marker...');
        // Carica anche il catalog quando cambia la configurazione
        //#FZ catalog20 commentato
      //this.loadCatalogConfiguration();
        this.updateAllMarkersPopups();
      } else {
        this.logger.debug('actia-map', 'POPUP UPDATE - Nessuna configurazione o marker, popup non aggiornati');
      }
    });

    // Carica catalog v2 e ricostruisce mergedFieldsMap ad ogni cambio di mappingConfig
    this.store.select(getApplySelectedCustomer).pipe(
      take(1),
      switchMap(customer =>
        customer?.uid
          ? this.catalogService.getCatalogForCustomer(customer.uid)
          : of({ data: [], result: '', errorDescription: null } as CatalogResponseV2)
      ),
      switchMap(catalog =>
        this.store.select(selectMappingConfig).pipe(
          map(config => ({ catalog, config }))
        )
      )
    ).subscribe(({ catalog, config }) => {
      this.catalogVisibleFieldNames = new Set(
        catalog.data.filter(i => i.visible !== false).map(i => i.name)
      );
      const fields = this.catalogService.buildMapConfigFields(catalog.data, config);
      // Indicizzata per "scope|name" (stesso nome tecnico possibile in scope diversi), con fallback per solo nome
      this.mergedFieldsMap = {};
      Object.values(fields).forEach(scopeFields =>
        scopeFields.forEach(f => {
          this.mergedFieldsMap[buildFieldConfigKey(f.scope, f.key)] = f;
          if (!this.mergedFieldsMap[f.key]) this.mergedFieldsMap[f.key] = f;
        })
      );
    });

    // Le proprietà meteo verranno inizializzate quando la mappa viene creata
  }

  /**
   * Inizializza le proprietà per la gestione del meteo
   */
  private initWeatherProperties(): void {
    this.weatherApiKey = environment.weatherApiKey || '';
    this.weatherApiBaseUrl = environment.weatherApiUrl || '';

    this.weatherLayerOpts = {
      accumulated_precipitation: {
        op: 'PA0',
        palette: '0:00000000;0.1:C8969600;0.2:9696AA00;0.5:FFF150;1:FFD000;10:FF8800;140:9F4D00',
        paletteArray: [{ 0: "00000000" }, { 0.1: "C8969600" }, { 0.2: "9696AA00" }, { 0.5: "FFF150" }, { 1: "FFD000" }, { 10: "FF8800" }, { 140: "9F4D00" }],
        layerName: this.translateService.instant('global.weatherLayers.accumulatedPrecipitation'),
        unitOfMeasure: 'mm',
        iconName: 'fa-solid fa-cloud-showers-heavy'
      },
      accumulated_precipitation_snow: {
        op: 'PAS0',
        palette: '0:00000000;5:0AD6FF;10:0E7DFB;25.076:070BED',
        paletteArray: [{ 0: "00000000" }, { 5: "0AD6FF" }, { 10: "0E7DFB" }, { 25.076: "070BED" }],
        layerName: this.translateService.instant('global.weatherLayers.accumulatedPrecipitationSnow'),
        unitOfMeasure: 'mm',
        iconName: 'fa-solid fa-snowflake'
      },
      wind_speed: {
        op: 'WS10',
        palette: '1:FFFFFF00;5:FFCCE4;15:FF99C8;25:F65198;50:E72BA5;100:D704B2;200:9702A2',
        paletteArray: [{ 1: "FFFFFF00" }, { 5: "FFCCE4" }, { 15: "FF99C8" }, { 25: "F65198" }, { 50: "E72BA5" }, { 100: "D704B2" }, { 200: "9702A2" }],
        layerName: this.translateService.instant('global.weatherLayers.windSpeed'),
        unitOfMeasure: 'm/s',
        iconName: 'fa-solid fa-wind'
      },
      winds: {
        op: 'WND',
        palette: '1:FFFFFF00;5:FFCCE4;15:FF99C8;25:F65198;50:E72BA5;100:D704B2;200:9702A2',
        paletteArray: [{ 1: "FFFFFF00" }, { 5: "FFCCE4" }, { 15: "FF99C8" }, { 25: "F65198" }, { 50: "E72BA5" }, { 100: "D704B2" }, { 200: "9702A2" }],
        layerName: this.translateService.instant('global.weatherLayers.windSpeedDirection'),
        unitOfMeasure: 'm/s',
        iconName: 'fa-solid fa-tornado'
      },
      air_temperature: {
        op: 'TA2',
        palette: '-65:821692;-55:821692;-45:821692;-40:821692;-30:8257DB;-20:208CEC;-10:20C4E8;0:23DDDD;10:C2FF28;20:FFF028;25:FFC228;30:FC8014',
        paletteArray: [{ "-65": "821692" }, { "-55": "821692" }, { "-45": "821692" }, { "-40": "821692" }, { "-30": "8257DB" }, { "-20": "208CEC" }, { "-10": "20C4E8" }, { "0": "23DDDD" }, { "10": "C2FF28" }, { "20": "FFF028" }, { "25": "FFC228" }, { "30": "FC8014" }],
        layerName: this.translateService.instant('global.weatherLayers.airTemperature'),
        unitOfMeasure: '°C',
        iconName: 'fa-solid fa-temperature-high'
      },
      dew_point: {
        op: 'TD2',
        palette: '-65:821692;-55:821692;-45:821692;-40:821692;-30:8257DB;-20:208CEC;-10:20C4E8;0:23DDDD;10:C2FF28;20:FFF028;25:FFC228;30:FC8014',
        paletteArray: [{ "-65": "821692" }, { "-55": "821692" }, { "-45": "821692" }, { "-40": "821692" }, { "-30": "8257DB" }, { "-20": "208CEC" }, { "-10": "20C4E8" }, { "0": "23DDDD" }, { "10": "C2FF28" }, { "20": "FFF028" }, { "25": "FFC228" }, { "30": "FC8014" }],
        layerName: this.translateService.instant('global.weatherLayers.dewPointTemperature'),
        unitOfMeasure: '°C',
        iconName: 'fa-solid fa-leaf'
      },
      relative_humidity: {
        op: 'HRD0',
        palette: '0:db1200;20:965700;40:ede100;60:8bd600;80:00a808;100:000099;100.1:000099',
        paletteArray: [{ 0: "db1200" }, { 20: "965700" }, { 40: "ede100" }, { 60: "8bd600" }, { 80: "00a808" }, { 100: "000099" }, { 100.1: "000099" }],
        layerName: this.translateService.instant('global.weatherLayers.relativeHumidity'),
        unitOfMeasure: '%',
        opacity: 0.7,
        iconName: 'fa-solid fa-droplet'
      },
      cloudiness: {
        op: 'CL',
        palette: '0:FFFFFF00;10:FDFDFF19;20:FCFBFF26;30:FAFAFF33;40:F9F8FF4C;50:F7F7FF66;60:F6F5FF8C;70:F4F4FFBF;80:E9E9DFCC;90:DEDEDED8;100:D2D2D2FF;200:D2D2D2FF',
        paletteArray: [{ 0: "FFFFFF00" }, { 10: "FDFDFF19" }, { 20: "FCFBFF26" }, { 30: "FAFAFF33" }, { 40: "F9F8FF4C" }, { 50: "F7F7FF66" }, { 60: "F6F5FF8C" }, { 70: "F4F4FFBF" }, { 80: "E9E9DFCC" }, { 90: "DEDEDED8" }, { 100: "D2D2D2FF" }, { 200: "D2D2D2FF" }],
        layerName: this.translateService.instant('global.weatherLayers.cloudiness'),
        unitOfMeasure: '%',
        iconName: 'fa-solid fa-cloud'
      }
    };
  }

  // INIZIALIZZO LA MAPPA BASE
  initMap(containerId: string, options: L.MapOptions = {}): L.Map {

    if (this.map && this.map.getContainer().id === containerId) {
      // console.log('Map already exists, returning existing instance');
      return this.map;
    }

    if (this.map) {
      // console.log('Destroying existing map before creating a new one');
      this.map.remove();
      this.map = null as any;
    }
   // console.log(this.initMap.name, 'called with containerId:', containerId, 'and options:', options);
    // Imposta i valori di default per center e zoom se non specificati
    const defaultCenter: L.LatLngExpression = [48.8566, 2.3522];
    const defaultZoom = 12;

    const center = options.center || defaultCenter;
    const zoom = options.zoom ?? defaultZoom; // Utilizza l'operatore nullish coalescing

    if (options.center || options.zoom) {
      this.map = L.map(containerId, {
        zoomControl: false, // Disabilita il controllo di zoom predefinito
        minZoom: 2, // Livello di zoom minimo
        maxZoom: 20, // Livello di zoom massimo,
        center: center,
        zoom: zoom
      });

      // L.marker(defaultCenter).addTo(this.map).bindPopup('prova').openPopup();
    } else {
      this.map = L.map(containerId, {
        zoomControl: false, // Disabilita il controllo di zoom predefinito
        minZoom: 2, // Livello di zoom minimo
        maxZoom: 20 // Livello di zoom massimo,
      });
    }
    // this.map = L.map(containerId, {
    //   center: [48.8566, 2.3522],
    //   zoom: 12
    // });7

    // // Sostituisci con le nuove definizioni dei layer
    // const normalDayLayer = L.tileLayer(
    //   `https://maps.hereapi.com/v3/tiles/mc/explore.day/{z}/{x}/{y}/png8?apiKey=${environment.hereApiKey}`,
    //   {
    //     attribution,
    //     maxZoom: 20,
    //   }
    // );

    // const satelliteDayLayer = L.tileLayer(
    //   `https://maps.hereapi.com/v3/tiles/mc/explore.satellite.day/{z}/{x}/{y}/png8?apiKey=${environment.hereApiKey}`,
    //   {
    //     attribution,
    //     maxZoom: 20,
    //   }
    // );
    //     const stadiaAlidadeSatelliteLayer = L.tileLayer(
    //       `https://tiles.stadiamaps.com/tiles/alidade_satellite/{z}/{x}/{y}{r}.png?api_key=${environment.stadiaApyKey}`,
    //       {
    //         attribution,
    //         maxZoom: 20,
    //       }
    //     );

    //     const stadiaOsmBrightLayer = L.tileLayer(
    //       `https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png?api_key=${environment.stadiaApyKey}`,
    //       {
    //         attribution,
    //         maxZoom: 20,
    //       }
    //     );

    //  //   normalDayLayer.addTo(this.map);

    //     const baseLayers = {
    //       'Normal Day': normalDayLayer,
    //       'Satellite Day': satelliteDayLayer,
    //       'Stadia Outdoors': stadiaAlidadeSatelliteLayer,
    //       'Stadia OSM Bright': stadiaOsmBrightLayer,
    //     };

    //     L.control
    //       .layers(baseLayers, {}, { position: 'bottomright' })
    //       .addTo(this.map);
    // Aggiungi i layer base tramite il metodo addBaseLayers

    // PRIMA aggiungi la scala (apparirà sotto)
    L.control.scale({
      position: 'bottomright',
      maxWidth: 200,
      metric: true,
      imperial: false,
      updateWhenIdle: true
    }).addTo(this.map);


    this.addBaseLayers();
    this.initializeDrawingControls();

    L.control.zoom({ position: 'bottomright' }).addTo(this.map);

    // Aggiungi evento tasto destro per selezione partenza/arrivo
  //   this.map.on('contextmenu', (e: L.LeafletMouseEvent) => {
  //     // Rimuovi eventuali marker temporanei precedenti
  //     if (this.tempMarker) {
  //       this.map?.removeLayer(this.tempMarker);
  //     }

  //     // Crea un marker temporaneo nella posizione del clic
  //     this.tempMarker = L.marker(e.latlng, {
  //       icon: L.divIcon({
  //         html: `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="41" viewBox="0 0 25 41">
  //     <path d="M12.5 0C5.596 0 0 5.596 0 12.5C0 21.875 12.5 41 12.5 41S25 21.875 25 12.5C25 5.596 19.404 0 12.5 0zm0 17.5c-2.761 0-5-2.239-5-5s2.239-5 5-5 5 2.239 5 5-2.239 5-5 5z"
  //     fill="#888888" stroke="#fff" stroke-width="1"/>
  //   </svg>`,
  //         className: '',
  //         iconSize: [25, 41],
  //         iconAnchor: [12, 31]
  //       })
  //     }).addTo(this.map!);

  //     // Verifica se ci sono già punti sulla mappa
  //     const hasPoints = this.hasRoutePoints();
  //     let popupContent = `
  //   <div style="display: flex; flex-direction: column; gap: 8px;">
  //     <button id="setStartPoint" style="padding: 6px 12px; border-radius: 4px; background: #1976d2; color: #fff; border: none; cursor: pointer;">Imposta come partenza</button>
  //     <button id="setEndPoint" style="padding: 6px 12px; border-radius: 4px; background: #3ea463; color: #fff; border: none; cursor: pointer;">Imposta come arrivo</button>
  // `;

  //     // Aggiungi il bottone di eliminazione solo se ci sono punti
  //     if (hasPoints) {
  //       popupContent += `
  //     <button id="deletePoints" style="padding: 6px 12px; border-radius: 4px; background: #dc3545; color: #fff; border: none; cursor: pointer;">Elimina punti</button>
  //   `;
  //     }

  //     // Chiudi il div
  //     popupContent += `</div>`;

  //     // Crea e mostra il popup
  //     const popup = L.popup()
  //       .setLatLng(e.latlng)
  //       .setContent(popupContent)
  //       .openOn(this.map!);

  //     // Aggiungi evento per rimuovere il marker se il popup viene chiuso
  //     popup.on('remove', () => {
  //       if (this.tempMarker) {
  //         this.map?.removeLayer(this.tempMarker);
  //         this.tempMarker = null;
  //       }
  //     });

  //     setTimeout(() => {
  //       const startBtn = document.getElementById('setStartPoint');
  //       const endBtn = document.getElementById('setEndPoint');
  //       const deleteBtn = document.getElementById('deletePoints');
  //       const routeCalculation = document.getElementById('routeCalculation');
  //       if (startBtn) {
  //         startBtn.onclick = () => {
  //           this.setRoutePoint('start', e.latlng);
  //           const startAddress$ = this.vehicleService.getAddressFromCoordinates(e.latlng.lat, e.latlng.lng);
  //           startAddress$.subscribe((address: string) => {
  //             this.setRouteStartPoint(e.latlng.lat, e.latlng.lng, address);
  //             this.map?.closePopup();
  //           });
  //         };
  //       }
  //       if (endBtn) {
  //         endBtn.onclick = () => {
  //           this.setRoutePoint('end', e.latlng);
  //           const endAddress = this.vehicleService.getAddressFromCoordinates(e.latlng.lat, e.latlng.lng);
  //           endAddress.subscribe((address: string) => {
  //             this.setRouteEndPoint(e.latlng.lat, e.latlng.lng, address);
  //             this.map?.closePopup();
  //           });
  //           if (routeCalculation) {
  //             routeCalculation.classList.remove('bg-white');
  //             routeCalculation.classList.add('bg-green-600');
  //           }
  //           this.openSearchRoute.emit(true);
  //           this.map?.closePopup();
  //         };
  //       }
  //       if (deleteBtn) {
  //         deleteBtn.onclick = () => {
  //           this.deleteRoutePoints();
  //           // if (this.tempMarker) {
  //           //   this.map?.removeLayer(this.tempMarker);
  //           //   this.tempMarker = null;
  //           // }
  //           // // Rimuovi marker precedente se esiste
  //           // if (this._routeStartMarker) {
  //           //   this.map?.removeLayer(this._routeStartMarker);
  //           //   this._routeStartMarker = null;
  //           // }
  //           // if (this._routeEndMarker) {
  //           //   this.map?.removeLayer(this._routeEndMarker);
  //           //   this._routeEndMarker = null;
  //           // }
  //           // this.clearRouteStartPoint();
  //           // this.clearRouteEndPoint();
  //           // this.map?.closePopup();
  //         };
  //       }
  //     }, 50);
  //   });

    // Inizializza le proprietà meteo ora che la mappa è pronta e le traduzioni sono caricate
    this.initWeatherProperties();

    // Inizializza il controllo meteo dopo che le proprietà sono state impostate
    this.initializeWeatherControl();

    return this.map;
  }

  getMap(): L.Map | undefined {
    return this.map;
  }

  setMap(map: L.Map): void {
    this.map = map;
  }

  setMarkersMap(markersMap: { [key: string]: L.Marker }): void {
    this.markersMap = markersMap;
  }

  setMarkerClusterGroup(clusterGroup: L.MarkerClusterGroup): void {
    this.markerClusterGroup = clusterGroup;
  }

  initFieldsLayerGroup(): void {
    if (!this.fieldsLayerGroup) {
      this.fieldsLayerGroup = L.layerGroup();
      if (this.map) {
        this.map.addLayer(this.fieldsLayerGroup);
      }
    }
  }

  setFieldsLayerGroup(layerGroup: L.LayerGroup): void {
    this.fieldsLayerGroup = layerGroup;
  }

  private refreshClusters(): void {
    if (this.markerClusterGroup) {
      this.markerClusterGroup.refreshClusters();

      // Per debug
      this.logger.debug('actia-map', `Cluster refreshed, markers remaining: ${Object.keys(this.markersMap).length}, markers in cluster: ${this.markerClusterGroup.getLayers().length}`);
    }
  }

  loadTrafficData2() {
    this.logger.warn('actia-map', 'Funzionalità traffico disabilitata: richiede HERE Maps API non più disponibile');
    this.logger.info('actia-map', 'TODO: Implementare alternativa per dati traffico con provider compatibile con Stadia Maps');

    // TODO: Opzioni alternative per dati traffico:
    // 1. Integrare con MapBox Traffic API
    // 2. Usare OpenStreetMap based traffic data
    // 3. Integrare con Google Traffic Layer
    // 4. Implementare overlay personalizzato con dati traffico di terze parti

    return;
  }

  drawTrafficFlow(flows: any[]) {
    const MIN_ZOOM = 11;
    const zoom = this.map?.getZoom() ?? 0;

    if (zoom < MIN_ZOOM) {
      this.clearTrafficFlow(); // eventualmente pulisci
      return; // non disegnare nulla
    }

    this.clearTrafficFlow();

    for (let f of flows) {
      const links = f.location?.shape?.links;
      if (!links || links.length === 0) continue;

      for (const link of links) {
        // Prepara i punti per Leaflet
        const latlngs = link.points.map((point: any) => [point.lat, point.lng]);

        const jam = f.currentFlow?.jamFactor ?? 0;
        let color = 'rgba(0,128,0,0.6)';

        if (jam > 4 && jam <= 7) {
          color = 'rgba(255,165,0,0.6)';
        } else if (jam > 7) {
          color = 'rgba(255,0,0,0.6)';
        }

        const polyline = L.polyline(latlngs, {
          color: color,
          weight: 4,
          opacity: 0.6
        });

        this.map?.addLayer(polyline);
        this.trafficMarkers.push(polyline);
      }
    }
  }

  drawIncidents(incidents: any[]) {
    /* const MIN_ZOOM = 11;
    const zoom = this.map?.getZoom() ?? 0;

    if (zoom < MIN_ZOOM) {
      this.clearIncidents();
      return;
    }
    this.clearIncidents();

    for (let inc of incidents) {
      const type = inc.incidentDetails?.type || 'unknown';
      const roadClosed = inc.incidentDetails?.roadClosed;

      // FILTRA: mostra incidenti o qualsiasi chiusura stradale
      const isAccident = type === 'accident';
      const isRoadClosed = roadClosed === true;

      if (!isAccident && !isRoadClosed) {
        continue;
      }

      const firstLink = inc.location?.shape?.links?.[0];
      const firstPoint = firstLink?.points?.[0];
      if (!firstPoint) continue;

      const { lat, lng } = firstPoint;

      let iconUrl = '';
      if (type === 'accident') {
        iconUrl = 'assets/images/inc.png';
      } else if (type === 'construction') {
        iconUrl = 'assets/images/lav.png';
      } else if (isRoadClosed) {
        iconUrl = 'assets/images/divieto.png'; // fallback per chiusure generiche
      } else {
        iconUrl = 'assets/images/pushPinGray.png';
      }

      // Crea l'icona Leaflet
      const icon = L.icon({
        iconUrl: iconUrl,
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32]
      });

      // Crea il marker Leaflet
      const marker = L.marker([lat, lng], { icon: icon });

      // Popup con descrizione incidente
      const description = inc.incidentDetails?.description?.value || '';
      const popupHtml = `
        <div style="
          min-width:180px;
          max-width:260px;
          padding: 12px 16px;
          border-radius: 10px;
          background: #fff;
          box-shadow: 0 2px 12px rgba(0,0,0,0.08);
          font-family: 'Segoe UI', Arial, sans-serif;
        ">
          <div style="font-size: 1.1em; font-weight: 600; color: #1e293b; margin-bottom: 6px;">
            ${type === 'accident'
          ? '🚧 ' + description
          : isRoadClosed
            ? '⛔ ' + description
            : 'ℹ️ Evento'
        }
          </div>
        </div>
      `;
      marker.bindPopup(popupHtml);

      // Cambia il cursore su hover
      marker.on('mouseover', () => {
        (this.map?.getContainer() as HTMLElement).style.cursor = 'pointer';
      });
      marker.on('mouseout', () => {
        (this.map?.getContainer() as HTMLElement).style.cursor = '';
      });

      marker.addTo(this.map!);
      this.incidentMarkers.push(marker);

      // Polyline
      const allPoints = inc.location?.shape?.links?.flatMap(
        (link: any) => link.points
      );
      if (allPoints?.length) {
        let color = '#000';
        if (type === 'accident') {
          color = 'rgba(255, 0, 0, 0.7)';
        } else if (type === 'construction') {
          color = 'rgba(255, 165, 0, 0.7)';
        } else if (isRoadClosed) {
          color = 'rgba(0, 0, 0, 0.7)';
        }

        const latlngs = allPoints.map((p: any) => [p.lat, p.lng]);
        const polyline = L.polyline(latlngs, {
          color: color,
          weight: 5,
          opacity: 0.7
        });
        polyline.addTo(this.map!);
        this.incidentMarkers.push(polyline);
      }
    } */
  }

  clearIncidents() {
    this.incidentMarkers.forEach((obj) => {
      if (obj && this.map?.hasLayer(obj)) {
        this.map.removeLayer(obj);
      }
    });
    this.incidentMarkers = [];
  }

  clearTrafficFlow() {
    for (const marker of this.trafficMarkers) {
      this.map?.removeLayer(marker);
    }
    this.trafficMarkers = [];
  }

  getFullLangCode(lang: string): string {
    const langMap: { [key: string]: string } = {
      it: 'it-IT',
      en: 'en-US',
      fr: 'fr-FR',
      de: 'de-DE',
      es: 'es-ES'
    };

    return langMap[lang] || 'en-US';
  }

  getDistanceBetween(
    p1: { lat: number; lng: number },
    p2: { lat: number; lng: number }
  ): number {
    const R = 6371; // km
    const dLat = ((p2.lat - p1.lat) * Math.PI) / 180;
    const dLng = ((p2.lng - p1.lng) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((p1.lat * Math.PI) / 180) *
      Math.cos((p2.lat * Math.PI) / 180) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  centerMapOnVehicle(vehicle: IotAsset): void {
    // console.log('centerMapOnVehicle', vehicle);
    if (!this.map || !this.markersMap) {
      return;
    }

    //const plate = vehicle.plate;
    const vin = vehicle.vin;
    const marker = this.markersMap[vin];

    const position = marker.getLatLng();

    if (!marker) {
      this.logger.warn('actia-map', `Marker not found for vin: ${vin}`);
      return;
    }

    // Dispatch an action to deselect all vehicles
    this.store.dispatch(VehicleActions.deselectAllIotAssets());

    // If the selected vehicle is the same, recenter the map and exit
    if (vehicle.vehicle_selected) {
      const lat = Number(vehicle.lat_current);
      const lon = Number(vehicle.lon_current);
      this.store.dispatch(
        VehicleActions.updateIotAssetSelected({ vin, selected: false })
      );
      this.refreshClusters();
      return;
    }

    // Select the new vehicle
    this.store.dispatch(
      VehicleActions.updateIotAssetSelected({ vin, selected: true })
    );

    // Inizializza la scia per questo veicolo, se non esiste già
    if (!this.vehicleTrails.has(vin)) {
      // Verifica se il veicolo è in movimento prima di inizializzare la scia
      const vehicleData = (marker as any).vehicleData;
      if (vehicleData && vehicleData.vehicle_status === 'MOVING') {
        this.initVehicleTrail(vin, position);
        // console.log(`Scia inizializzata per il veicolo ${vin} nella selezione`);
      }
    }


    const lat = Number(vehicle.lat_current);
    const lon = Number(vehicle.lon_current);
    this.map.setView([lat, lon], 15); // Center the map on the selected vehicle

    // Forza il refresh dei cluster
    this.refreshClusters();
  }

  updateMarkers(
    vehicles: IotAsset[],
    isFirstLoad: boolean = true,
    showDriver: boolean = false
  ): void {
    if (!this.map || !this.markerClusterGroup) {
      return;
    }

    // Gestisci esplicitamente il caso dell'array vuoto
    if (!vehicles || vehicles.length === 0) {
      // console.log('Array veicoli vuoto, rimuovo tutti i marker dalla mappa');

      // Rimuovi tutti i marker esistenti
      Object.keys(this.markersMap).forEach((vin) => {
        const marker = this.markersMap[vin];
        this.markerClusterGroup?.removeLayer(marker); // AGGIUNGI QUESTA RIGA
      });

      // Rimuovi anche tutte le scie
      this.vehicleTrails.forEach((trail, vin) => {
        if (trail.polyline) {
          this.map?.removeLayer(trail.polyline);
        }
      });
      this.vehicleTrails.clear();


      // Svuota la mappa dei marker
      this.markersMap = {};

      // Forza il refresh dei cluster
      this.refreshClusters();

      // Log addizionale per debug
      console.log(
        'Dopo la rimozione, markers rimanenti:',
        Object.keys(this.markersMap).length
      );

      return;
    }

    const bounds = L.latLngBounds([]);
    const currentPlates = vehicles.map((vehicle) => vehicle.vin);

    // Rimuovi i marker per i veicoli che non sono più presenti
    Object.keys(this.markersMap).forEach((vin) => {
      if (!currentPlates.includes(vin)) {
        const marker = this.markersMap[vin];
        this.markerClusterGroup?.removeLayer(marker); // Rimuovi il marker dal cluster
        delete this.markersMap[vin]; // Rimuovi il marker dalla mappa dei marker

        // Rimuovi anche la scia se presente
        if (this.vehicleTrails.has(vin)) {
          const trail = this.vehicleTrails.get(vin);
          if (trail?.polyline) {
            this.map?.removeLayer(trail.polyline);
          }
          this.vehicleTrails.delete(vin);
        }


      }
    });

    //const lblDriver = this.translateService.instant('mapPage.driver');
    // const lblInternalID = this.translateService.instant('mapPage.internalId');
    // const lblStartTime = this.translateService.instant('mapPage.startTime');
    // const lblCurrentPosition = this.translateService.instant(
    //   'mapPage.currentPosition'
    // );
    // const lblDirection = this.translateService.instant('mapPage.direction');
    // const lblState = this.translateService.instant('mapPage.state');
    // const lblSince = this.translateService.instant('mapPage.since');
    // const lblLastUpdate = this.translateService.instant('mapPage.lastUpdate');
    // const lblTodayDistance = this.translateService.instant(
    //   'mapPage.todayDistance'
    // );
    // const lblTodayConsumption = this.translateService.instant(
    //   'mapPage.todayConsumption'
    // );
    // const lblFuelLevel1 = this.translateService.instant('mapPage.fuelLevel1');
    // const lblFuelLevel2 = this.translateService.instant('mapPage.fuelLevel2');

    // Helper method per costruire il popup content basato sulla configurazione
    const buildPopupContent = (vehicle: any, popupColorClass: string) => {
      let popupContent = `<div class="popup-content ${popupColorClass}" style="display: flex; flex-direction: column; gap: 8px;">`;

      // VIN sempre visibile
      const vin = vehicle.vin || '-';
      popupContent += `
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="font-style: italic;" class="text-xs">VIN:</div>
          <div style="font-weight: bold; text-align: right;" class="text-xs">${vin}</div>
        </div>`;

      // 🔧 LEGGI SEMPRE DALLO STORE NGRX per avere i dati aggiornati in tempo reale
      let currentConfig: any = null;
      this.store.select(selectMappingConfig)
        .pipe(take(1))
        .subscribe(config => {
          currentConfig = config;
        });

      if (currentConfig && currentConfig.fields) {
        // Filtra i campi che devono essere mostrati nel popup
        const filteredKeys = Object.keys(currentConfig.fields)
          .filter(storageKey => {
            const fieldConfig = currentConfig.fields[storageKey];
            const fieldName = extractNameFromFieldConfigKey(storageKey);
            const isBasicVisible = fieldConfig.visible !== false &&
              fieldConfig.showInPopup === true &&
              this.isCatalogVisible(fieldName);

            if (!isBasicVisible) return false;

            if (vehicle.can_map_name) {
              return this.vehicleService.isFieldVisibleForVehicle(fieldName, vehicle.can_map_name);
            }

            return true;
          });

        // Ordina per scope (come sidebar/dettagli) e, a parità di scope, per displayOrder
        const popupFields = this.sortPopupFields(filteredKeys, currentConfig.fields);

        // console.log('🎯 POPUP UPDATEMARKERS - Campi abilitati per popup (da STORE):', popupFields.length);
        // console.log('🎯 POPUP UPDATEMARKERS - Campi selezionati:', popupFields);
        // console.log('🎯 POPUP UPDATEMARKERS - Sto per generare popup content...');
       // console.log('🎯 POPUP UPDATEMARKERS - Campi selezionati:', popupFields);

        // Crea le righe per ogni campo abilitato
        popupFields.forEach(storageKey => {
          const fieldConfig = currentConfig.fields[storageKey];
          const fieldName = extractNameFromFieldConfigKey(storageKey);
          const label = this.generateFieldLabel(fieldName, fieldConfig);
          const value = this.formatPopupFieldValue(fieldName, fieldConfig, vehicle[fieldName]);

          popupContent += `
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <div style="font-style: italic;" class="text-xs">${label}:</div>
              <div style="font-weight: bold; text-align: right;" class="text-xs">${value}</div>
            </div>`;
        });

        // Altri campi configurabili aggiunti sopra (VIN già sempre presente)
      } else {
        // Fallback se non c'è configurazione - VIN già aggiunto sopra
        console.log('⚠️ Nessuna configurazione trovata nello store per popup');
      }

      popupContent += '</div>';
      return popupContent;
    };

    vehicles.forEach((vehicle) => {
      const lat = Number(vehicle.lat_current);
      const lon = Number(vehicle.lon_current);
      const vehicle_status = vehicle.vehicle_status;
    //  const plate = vehicle.plate;
      const vin = vehicle.vin;
      const cliente = vehicle.code_customer;
      const angle = vehicle.angle_current;
      const isSelected = vehicle.vehicle_selected;
  //     const driver =
  // (vehicle.drv1_firstname ? vehicle.drv1_firstname : 'NA') + ' ' +
  // (vehicle.drv1_lastname ? vehicle.drv1_lastname : 'N/A');
      const startime = vehicle.status_entered_at
        ? this.datePipe.transform(
          vehicle.status_entered_at,
          'dd/MM/yyyy HH:mm:ss'
        ) // Formatta la data
        : 'N/A'; // Mostra "N/A" se la data non è disponibile

      // const permanenza_stato = vehicle.status_entered_at
      //   ? Math.abs(
      //     new Date().getTime() - new Date(vehicle.status_entered_at).getTime()
      //   ) // Differenza in millisecondi
      //   : 0; // Se una delle due date è null o undefined, imposta a 0

      // Calcola la permanenza dello stato in secondi

const permanenza_stato = vehicle.fromtime_last_update_status ?? 0; // valore in secondi

const permanenza_stato_in_ore = Math.floor(permanenza_stato / 3600); // Ore
const permanenza_stato_in_minuti = Math.floor((permanenza_stato % 3600) / 60); // Minuti rimanenti

const permanenza_formattata =
  permanenza_stato_in_ore > 0
    ? `${permanenza_stato_in_ore}h:${permanenza_stato_in_minuti} min`
    : `${permanenza_stato_in_minuti} min`;

      const lastUpdate = vehicle.updated_at
        ? this.datePipe.transform(vehicle.updated_at, 'dd/MM/yyyy HH:mm:ss') // Formatta la data
        : 'N/A'; // Mostra "N/A" se la data non è disponibile
      // const odo = `${vehicle.odo}/km`
      const currentPosition = vehicle.addressCurrent || 'Posizione in caricamento...';
      const fuelConsumption =
        vehicle.total_fuel_consumed_liters != null
          ? `${this.utlService.formatNumber(vehicle.total_fuel_consumed_liters, 2)} l`
          : 'N/A';
      const internalId = vehicle.vehicleInfo?.internalId;
      const totDistance =
        vehicle.total_distance_km != null
          ? `${this.utlService.formatNumber(vehicle.total_distance_km)} km`
          : 'N/A';
      const fuelLevel1 =
        vehicle.fuel_level_1 != null ? `${vehicle.fuel_level_1}%` : 'N/A';
      const fuelLevel2 =
        vehicle.fuel_level_2 != null ? `${vehicle.fuel_level_2}%` : 'N/A';
      if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
        console.warn(`[marker] SKIP ${vin} — lat=${lat} lon=${lon}`);
        return;
      }
      console.log(`[marker] CREO ${vin} @ [${lat}, ${lon}] status=${vehicle_status}`);
      const markerColorClass =
        {
          PARKED: 'actia-marker-icon-gray',
          MOVING: 'actia-marker-icon-green',
          IDLE: 'actia-marker-icon-orange',
          UNKNOWN: 'actia-marker-icon-white',
          NOTCONNECTED: 'actia-marker-icon-white'
        }[vehicle_status] || 'actia-marker-icon-blue';

      const labelColorClass =
        {
          PARKED: 'marker-label-parked',
          MOVING: 'marker-label-moving',
          IDLE: 'marker-label-idle',
          UNKNOWN: 'marker-label-unknown',
          NOTCONNECTED: 'marker-label-notconnected'
        }[vehicle_status] || 'marker-label-default';

      const popupColorClass =
        {
          PARKED: 'popup-gray',
          MOVING: 'popup-green',
          IDLE: 'popup-orange',
          UNKNOWN: 'popup-white',
          NOTCONNECTED: 'popup-white'
        }[vehicle_status] || 'popup-default';

      const vehicleIconClass = this.vehicleIconClass(vehicle);
      const selectedClass = isSelected ? 'selected-marker-label' : '';
      const labelContent =  vin;
      const markerArrowClass =  'hide-driver';

      const markerHtml = `
      <div class="custom-marker-icon">
               <div class="marker-shadow"></div>
               <div class="actia-marker-icon ${markerColorClass}"></div>
                <div class="marker-label ${labelColorClass} ${selectedClass}  flex justify-between items-center w-32 h-3">

                ${vehicle_status === 'PARKED' ||
          vehicle_status === 'NOTCONNECTED'
          ? '<div style="width: 18px;"></div>' // Spazio vuoto che mantiene all'allineamento
          : this.getCardinalDirectionHtmlIcon(vehicle.angle_current)
        }

                 <div class="separator h-6 w-px bg-gray-300 mx-2"></div>
                <div>
                  <i class="fas ${vehicleIconClass} vehicle-icon  pr-2"></i>
                </div>
                <div class="truncate grow">
                ${showDriver
          ? `<div class="truncate text-xs">${vehicle.drv1_firstname ? vehicle.drv1_firstname:'N/A'}</div>
                    <div class="truncate text-xs">${vehicle.drv1_lastname ? vehicle.drv1_lastname : 'N/A'}</div>`
          : `<div class="truncate text-xs">${vin}</div>`
        }
                </div>
                </div
      </div>
`;

      const markerIcon = L.divIcon({
        className: 'custom-marker-icon',
        html: markerHtml,
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [85, -25]
      });

      if (this.markersMap[vin]) {
        const existingMarker = this.markersMap[vin];
        const existingLatLng = existingMarker.getLatLng();
        const existingVehicle_status = (existingMarker as any).vehicle_status;
        const existingSelected = (existingMarker as any).vehicle_selected;
        // #fz24072025 aggiunta questa condizione per aggiornare il tempo in cui il veicolo è in questo stato
        const existingEventUpdateTime  = (existingMarker as any).vehicleData?.fromtime_last_update_event || 0;


        const hasMoved = existingLatLng.lat !== lat || existingLatLng.lng !== lon;

        // Gestisci la scia per i veicoli selezionati in movimento
        if (isSelected && hasMoved && vehicle_status === 'MOVING') {
          this.updateVehicleTrail(vin, L.latLng(lat, lon));
        } else if (!isSelected && this.vehicleTrails.has(vin)) {
          // Rimuovi la scia se il veicolo non è più selezionato
          this.removeVehicleTrail(vin);
        }


        if (
          existingLatLng.lat !== lat ||
          existingLatLng.lng !== lon ||
          existingVehicle_status !== vehicle_status ||
          existingSelected !== isSelected ||
          existingEventUpdateTime !== vehicle.fromtime_last_update_event
        ) {
          existingMarker.setLatLng([lat, lon]);
          existingMarker.setIcon(markerIcon);
          (existingMarker as any).vehicle_status = vehicle_status;
          (existingMarker as any).vehicle_selected = isSelected;
          (existingMarker as any).vehicleData = vehicle;

          const popupContent = buildPopupContent(vehicle, popupColorClass);

// Aggiorna solo il popup se è aperto questo per evitare di aggioanre suttto quando cambia lo stato
          if (existingMarker.isPopupOpen && existingMarker.isPopupOpen()) {
            // console.log('Popup aperto, aggiorno il contenuto');
    existingMarker.setPopupContent(popupContent);
  }
        }
      } else {
        const marker = L.marker([lat, lon], { icon: markerIcon });
        (marker as any).vehicle_status = vehicle_status;
        (marker as any).vehicle_selected = isSelected;
        (marker as any).vehicleData = vehicle;

        // AGGIUNGI QUI GLI EVENT LISTENER
        marker.on('click', (e) => {
          // console.log(`Marker cliccato per veicolo: ${plate} (${vin})`);
          //alert(`Marker cliccato per veicolo: ${plate} (${vin})`);

          // Rigenera il popup content con le traduzioni aggiornate AD OGNI CLICK
          const updatedPopupContent = buildPopupContent(vehicle, popupColorClass);
          marker.setPopupContent(updatedPopupContent);

          // Notifica alla sidebar tramite il servizio
          this.mapContainerService.setSelectedIotAssetFromMap(vehicle);
        });

        // Rigenera il popup anche quando viene aperto (per popup già esistenti)
        marker.on('popupopen', (e) => {
          console.log('🔄 POPUP OPENED - Rigenerando contenuto con traduzioni aggiornate');
          const updatedPopupContent = buildPopupContent(vehicle, popupColorClass);
          marker.setPopupContent(updatedPopupContent);
        });

        // Binding iniziale del popup (sarà aggiornato al primo click/open)
        const initialPopupContent = buildPopupContent(vehicle, popupColorClass);
        marker.bindPopup(initialPopupContent);





        this.markerClusterGroup?.addLayer(marker);
        this.markersMap[vin] = marker;
        console.log(`[marker] AGGIUNTO ${vin} — markersMap size=${Object.keys(this.markersMap).length}`);
        // Inizializza la scia se il veicolo è selezionato e in movimento
        if (isSelected && vehicle_status === 'MOVING') {
          this.initVehicleTrail(vin, L.latLng(lat, lon));
        }


      }



      bounds.extend([lat, lon]);
    });

    if (isFirstLoad && bounds.isValid()) {
      this.map.fitBounds(bounds, { padding: [10, 10] });
    }
  }

  // Metodo per aggiornare solo gli indirizzi dei marker esistenti
  updateMarkersAddresses(vehicles: IotAsset[]): void {
    if (!this.map || !this.markerClusterGroup) {
      return;
    }

    vehicles.forEach((vehicle) => {
      const vin = vehicle.vin;
      const marker = this.markersMap[vin];

      if (marker && vehicle.addressCurrent && vehicle.addressCurrent !== 'Caricamento indirizzo...' && vehicle.addressCurrent !== 'Posizione in caricamento...') {
        // Aggiorna solo il popup del marker esistente
        const lblCurrentPosition = this.translateService.instant('mapPage.currentPosition');

        // Ottieni il contenuto del popup attuale
        const currentPopup = marker.getPopup();
        if (currentPopup) {
          const currentContent = currentPopup.getContent() as string;

          // Sostituisci la riga della posizione corrente nel popup
          const updatedContent = currentContent.replace(
            /<div style="display: flex; justify-content: space-between; align-items: center;">\s*<div style="font-style: italic;" class="text-xs">[^<]*lblCurrentPosition[^<]*<\/div>\s*<div style="font-weight: bold; text-align: right;" class="text-xs">[^<]*<\/div>\s*<\/div>/,
            `<div style="display: flex; justify-content: space-between; align-items: center;">
              <div style="font-style: italic;" class="text-xs">${lblCurrentPosition}:</div>
              <div style="font-weight: bold; text-align: right;" class="text-xs">${vehicle.addressCurrent}</div>
            </div>`
          );

          // Aggiorna il popup
          marker.bindPopup(updatedContent);
        }
      }
    });
  }


  // Metodi per gestire le scie dei veicoli

  // Inizializza la scia per un veicolo
  private initVehicleTrail(vin: string, position: L.LatLng): void {
    // Crea una nuova polyline con la posizione iniziale
    const polyline = L.polyline([position], {
      color: '#FFCC00',  // Giallo
      weight: 5,         // Spessore della linea
      opacity: 0.7,      // Opacità
      lineJoin: 'round'  // Arrotonda le giunzioni
    }).addTo(this.map!);

    // Salva la scia nella mappa delle scie
    this.vehicleTrails.set(vin, {
      positions: [position],
      polyline: polyline
    });

    // console.log(`Inizializzata scia per veicolo ${vin}`);
  }

  // Aggiorna la scia per un veicolo in movimento
  private updateVehicleTrail(vin: string, newPosition: L.LatLng): void {
    const trail = this.vehicleTrails.get(vin);

    if (!trail) {
      this.initVehicleTrail(vin, newPosition);
      return;
    }

    // Aggiungi la nuova posizione all'array delle posizioni
    trail.positions.push(newPosition);

    // Limita il numero di punti nella scia
    if (trail.positions.length > this.TRAIL_MAX_POINTS) {
      trail.positions.shift(); // Rimuovi il punto più vecchio
    }

    // Aggiorna la polyline con le nuove posizioni
    if (trail.polyline) {
      trail.polyline.setLatLngs(trail.positions);
    }
  }

  // Rimuovi la scia di un veicolo
  private removeVehicleTrail(vin: string): void {
    const trail = this.vehicleTrails.get(vin);

    if (trail && trail.polyline) {
      // Rimuovi la polyline dalla mappa
      this.map?.removeLayer(trail.polyline);

      // Rimuovi la scia dalla mappa delle scie
      this.vehicleTrails.delete(vin);

      // console.log(`Rimossa scia per veicolo ${vin}`);
    }
  }



  initClusterGroup(): void {
    this.markerClusterGroup = L.markerClusterGroup({
      maxClusterRadius: 50,
      disableClusteringAtZoom: 18,
      iconCreateFunction: (cluster) => {
        const markers = cluster.getAllChildMarkers();

        // Verifica se uno dei marker ha `vehicle_selected === true`
        const hasSelectedVehicle = markers.some(
          (m: any) => m.vehicle_selected === true
        );

        const parked = markers.filter(
          (m: any) => m.vehicle_status === 'PARKED'
        ).length;
        const moving = markers.filter(
          (m: any) => m.vehicle_status === 'MOVING'
        ).length;
        const idle = markers.filter(
          (m: any) => m.vehicle_status === 'IDLE'
        ).length;
        const unknown = markers.filter(
          (m: any) => m.vehicle_status === 'UNKNOWN'
        ).length;

        const notconnected = markers.filter(
          (m: any) => m.vehicle_status === 'NOTCONNECTED'
        ).length;
        const svg = this.createStaticDonutSVG(
          parked,
          moving,
          idle,
          unknown,
          notconnected
        );

        // Aggiungi una classe o uno stile personalizzato se c'è un veicolo selezionato
        const clusterClass = hasSelectedVehicle
          ? 'custom-cluster-icon selected-cluster'
          : 'custom-cluster-icon';

        return L.divIcon({
          html: svg,
          className: clusterClass,
          iconSize: [50, 50],
          iconAnchor: [25, 25]
        });
      }
    });

    if (this.map && this.markerClusterGroup) {
      this.map.addLayer(this.markerClusterGroup);
    }
  }

  private createStaticDonutSVG(
    parked: number,
    moving: number,
    idle: number,
    unknown: number,
    notconneted: number
  ): string {
    const total = parked + moving + idle + unknown + notconneted;
    const circumference = 100; // semplificazione

    if (total === 0) {
      return `
        <svg width="50" height="50" viewBox="0 0 42 42" xmlns="http://www.w3.org/2000/svg">
          <circle cx="21" cy="21" r="15.915" fill="white" />
          <text x="21" y="21" text-anchor="middle" dy=".3em" font-size="10" fill="#000">0</text>
        </svg>
      `;
    }

    const getSegment = (
      value: number,
      offset: number,
      color: string
    ): string => {
      const percentage = (value / total) * circumference;
      return `
        <circle
          cx="21"
          cy="21"
          r="15.915"
          fill="transparent"
          stroke="${color}"
          stroke-width="5"
          stroke-dasharray="${percentage} ${circumference - percentage}"
          stroke-dashoffset="${offset}"
        />
      `;
    };

    // Calcolo offset progressivi
    const parkedP = (parked / total) * circumference;
    const movingP = (moving / total) * circumference;
    const idleP = (idle / total) * circumference;

    const parkedSegment = getSegment(parked, 25, '#696969');
    const movingSegment = getSegment(moving, 25 - parkedP, '#3FB346');
    const idleSegment = getSegment(idle, 25 - parkedP - movingP, '#e68a22');
    const unknownSegment = getSegment(
      unknown,
      25 - parkedP - movingP - idleP,
      '#ffffff'
    );
    const notconnectedSegment = getSegment(
      unknown,
      25 - parkedP - movingP - idleP,
      'white'
    );

    return `
      <svg width="50" height="50" viewBox="0 0 42 42" xmlns="http://www.w3.org/2000/svg">
        <circle cx="21" cy="21" r="15.915" fill="white" />
        ${parkedSegment}
        ${movingSegment}
        ${idleSegment}
        ${unknownSegment}
        ${notconnectedSegment}
        <text x="21" y="21" text-anchor="middle" dy=".3em" font-size="10" fill="#000">${total}</text>
      </svg>
    `;
  }

  addStatusControl(lblLoadingIn: string, lblRefreshingIn: string): void {
    if (!this.map) {
      console.error('La mappa non è stata inizializzata.');
      return;
    }

    const statusControl = new L.Control({ position: 'bottomleft' });

    // console.log('lblLoading:', lblLoadingIn);
    // console.log('lblRefreshing:', lblRefreshingIn);
    if (lblLoadingIn) this.lblLoading = lblLoadingIn;

    if (lblRefreshingIn) this.lblRefreshing = lblRefreshingIn;

    statusControl.onAdd = () => {
      const div = L.DomUtil.create(
        'div',
        'status-control flex flex-col gap-2 bg-white shadow-lg rounded-lg p-2 text-sm text-gray-800'
      );
      div.innerHTML = `
        <div class="loading-icon flex items-center gap-2" style="display: none;">
          <i class="fas fa-spinner fa-spin text-blue-500"></i>
          <span>${this.lblLoading}</span>
        </div>
        <div class="refresh-icon flex items-center gap-2" style="display: none;">
          <i class="fas fa-sync fa-spin text-green-500"></i>
          <span>${this.lblRefreshing}</span>
        </div>
      `;
      return div;
    };

    statusControl.addTo(this.map);

    // Salva il riferimento all'elemento DOM per aggiornamenti futuri
    this.statusControlElement = document.querySelector('.status-control');
  }

  updateStatusIcons(
    isLoading$: Observable<boolean>,
    isRefreshing$: Observable<boolean>
  ): void {
    if (!this.statusControlElement) {
      console.error('Lo statusControl non è stato inizializzato.');
      return;
    }

    const loadingIcon = this.statusControlElement.querySelector(
      '.loading-icon'
    ) as HTMLElement;
    const refreshIcon = this.statusControlElement.querySelector(
      '.refresh-icon'
    ) as HTMLElement;

    isLoading$.subscribe((isLoading) => {
      if (loadingIcon) {
        loadingIcon.style.display = isLoading ? 'flex' : 'none';
      }
    });

    isRefreshing$.subscribe((isRefreshing) => {
      if (refreshIcon) {
        refreshIcon.style.display = isRefreshing ? 'flex' : 'none';
      }
    });
  }

  addToolbar(changeTag: boolean = true,
    toggleCluster: boolean = true,
    fullScreen: boolean = true,
    reports: boolean = true,
    routeCalculation: boolean = true,
    prohibitions: boolean = true,
    pdfPrint: boolean = true,
    tutorial: boolean = true,
    weather: boolean = true,
    fieldLabels: boolean = true,
    geofence: boolean = true,
    instanceId: string = 'default'): void {
    if (!this.map) {
      console.error('La mappa non è stata inizializzata.');
      return;
    }

    // Controlla se esiste già una toolbar con questo instanceId
    const existingToolbar = document.querySelector(`[data-toolbar-instance="${instanceId}"]`);
    if (existingToolbar) {
      // console.log(`Toolbar con instanceId '${instanceId}' già esistente, non viene ricreata.`);
      return;
    }

    const mainColor = this.utilsService.getMainColor();

    const toolbarControl = new L.Control({ position: 'topleft' });

    toolbarControl.onAdd = () => {
      const div = L.DomUtil.create(
        'div',
        'horizontal-toolbar flex flex-col p-1 gap-1'
      ); // Cambia flex in flex-col

      // Aggiungi un attributo per identificare questa toolbar specifica
      div.setAttribute('data-toolbar-instance', instanceId);

      // Costruisci l'HTML dinamicamente in base ai parametri
      let buttonsHtml = '';

      if (changeTag) {
        buttonsHtml += `
        <div class="toolbar-btn binocular-btn flex items-center justify-center w-8 h-8 bg-white shadow-lg p-1 cursor-pointer changeTag" id="changeTag-${instanceId}">
          <i class="fa-solid fa-tag text-cyan-800 text-lg"></i>
        </div>
      `;
      }

      if (toggleCluster) {
        buttonsHtml += `
        <div class="toolbar-btn flex items-center justify-center w-8 h-8 shadow-lg p-1 cursor-pointer toggleCluster" id="toggleCluster-${instanceId}" style="background-color: ${mainColor};">
          <i class="fa-solid fa-circle-nodes text-gray-800 text-lg"></i>
        </div>
      `;
      }

      if (fullScreen) {
        buttonsHtml += `
        <div class="toolbar-btn flex items-center justify-center w-8 h-8 bg-white shadow-lg p-1 cursor-pointer fullScreen" id="fullScreen-${instanceId}">
          <i class="fas fa-maximize text-gray-800 text-lg"></i>
        </div>
      `;
      }

      if (reports) {
        buttonsHtml += `
        <div class="toolbar-btn flex items-center justify-center w-8 h-8 bg-white shadow-lg p-1 cursor-pointer reports" id="reports-${instanceId}">
          <i class="fa-solid fa-triangle-exclamation text-gray-800 text-lg"></i>
        </div>
      `;
      }

      if (routeCalculation) {
        buttonsHtml += `
        <div class="toolbar-btn flex items-center justify-center w-8 h-8 bg-white shadow-lg p-1 cursor-pointer routeCalculation" id="routeCalculation-${instanceId}">
          <i class="fa-solid fa-route text-gray-800 text-lg"></i>
        </div>
      `;
      }

      if (prohibitions) {
        buttonsHtml += `
        <div class="toolbar-btn flex items-center justify-center w-8 h-8 bg-white shadow-lg p-1 cursor-pointer prohibitions" id="prohibitions-${instanceId}">
          <i class="fa-solid fa-ban text-gray-800 text-lg"></i>
        </div>
      `;
      }

      // if (pdfPrint && environment.platform !== 'mobile') {
      //   buttonsHtml += `
      //   <div class="toolbar-btn flex items-center justify-center w-8 h-8 bg-white shadow-lg p-1 cursor-pointer pdfPrint" id="pdfPrint-${instanceId}">
      //     <i class="fa-solid fa-file-pdf text-gray-800 text-lg"></i>
      //   </div>
      // `;
      // }

       if (weather) {
        buttonsHtml += `
        <div class="toolbar-btn flex items-center justify-center w-8 h-8 bg-white shadow-lg p-1 cursor-pointer weather" id="weather-${instanceId}">
          <i class="fa-solid fa-cloud-sun text-gray-800 text-lg"></i>
        </div>
      `;
      }

      if (fieldLabels) {
        buttonsHtml += `
        <div class="toolbar-btn flex items-center justify-center w-8 h-8 bg-white shadow-lg p-1 cursor-pointer fieldLabels" id="fieldLabels-${instanceId}">
          <i class="fa-solid fa-wheat-awn text-gray-800 text-lg"></i>
        </div>
      `;
      }

      if (geofence) {
        buttonsHtml += `
        <div class="toolbar-btn flex items-center justify-center w-8 h-8 bg-white shadow-lg p-1 cursor-pointer geofence" id="geofence-${instanceId}">
          <i class="fa-solid fa-location-dot text-gray-800 text-lg"></i>
        </div>
      `;
      }

      if (tutorial) {
        buttonsHtml += `
        <div class="toolbar-btn flex items-center justify-center w-8 h-8 bg-white shadow-lg p-1 cursor-pointer tutorial" id="tutorial-${instanceId}">
          <i class="fa-solid fa-question text-gray-800 text-lg question"></i>
        </div>
      `;
      }



      div.innerHTML = `
      <div class="flex flex-row gap-1">
        ${buttonsHtml}
      </div>
    `;

      // Aggiungi gli eventi ai pulsanti
      setTimeout(() => {

        const changeTagButton = document.getElementById(`changeTag-${instanceId}`);
        const toogleClusterButton = document.getElementById(`toggleCluster-${instanceId}`);
        const fullScreenButton = document.getElementById(`fullScreen-${instanceId}`);
        const activateReports = document.getElementById(`reports-${instanceId}`);
        const routeCalculation = document.getElementById(`routeCalculation-${instanceId}`);
        const pdfPrintButton = document.getElementById(`pdfPrint-${instanceId}`);
        const prohibitions = document.getElementById(`prohibitions-${instanceId}`);
        const tutorial = document.getElementById(`tutorial-${instanceId}`);
        const weatherButton = document.getElementById(`weather-${instanceId}`);
        const fieldLabelsButton = document.getElementById(`fieldLabels-${instanceId}`);
        const geofenceButton = document.getElementById(`geofence-${instanceId}`);

        if (changeTagButton) {
          //  let showDriver = false; // Stato iniziale: mostra la targa
          let displayMode = 'vin'; // Possibili valori: 'vin', 'driver', 'internalId'
          changeTagButton.addEventListener('click', () => {
            if (!this.map || !this.markersMap) {
              console.warn('La mappa o i marker non sono inizializzati.');
              return;
            }

            // Alterna tra i tre stati in sequenza
            if (displayMode === 'vin') {
              displayMode = 'driver';
            } else if (displayMode === 'driver') {
              displayMode = 'internalId';
            } else {
              displayMode = 'vin';
            }

            // Alterna lo stato tra targa e conducente
            //   showDriver = !showDriver;

            // Cambia l'icona del pulsante in base allo stato
            const iconElement = changeTagButton.querySelector('i');
            if (iconElement) {
              switch (displayMode) {
                case 'driver':
                  iconElement.className =
                    'fa-solid fa-user text-cyan-800 text-lg';
                  break;
                case 'internalId':
                  iconElement.className =
                    'fa-solid fa-id-card text-cyan-800 text-lg';
                  break;
                default: // 'vin'
                  iconElement.className =
                    'fa-solid fa-tag text-cyan-800 text-lg';
              }
            }

            // Aggiorna i marker
            Object.values(this.markersMap).forEach((marker: any) => {
              const vehicle: IotAsset = marker.vehicleData; // Assumiamo che i dati del veicolo siano salvati nel marker
              if (!vehicle) return;

              const vehicle_status: string = vehicle.vehicle_status;
              const angle = vehicle.angle_current;
              const isSelected = vehicle.vehicle_selected;
  //           const driver =
  // (vehicle.drv1_firstname ? vehicle.drv1_firstname : 'N/A') + ' ' +
  // (vehicle.drv1_lastname ? vehicle.drv1_lastname : 'N/A');
              const vehicleIconClass = this.vehicleIconClass(vehicle);
              const selectedClass = isSelected ? 'selected-marker-label' : '';
              const vin = vehicle.vin;
              // const labelContent = showDriver ? driver : plate;

              const markerColorClass =
                {
                  PARKED: 'actia-marker-icon-gray',
                  MOVING: 'actia-marker-icon-green',
                  IDLE: 'actia-marker-icon-orange',
                  UNKNOWN: 'actia-marker-icon-white',
                  NOTCONNECTED: 'actia-marker-icon-white'
                }[vehicle_status] || 'actia-marker-icon-blue';

              const labelColorClass =
                {
                  PARKED: 'marker-label-parked',
                  MOVING: 'marker-label-moving',
                  IDLE: 'marker-label-idle',
                  UNKNOWN: 'marker-label-unknown',
                  NOTCONNECTED: 'marker-label-notconnected'
                }[vehicle_status] || 'marker-label-default';

              // Modifica questa parte per gestire i tre casi
              const markerHtml = `
   <div class="custom-marker-icon">
     <div class="marker-shadow"></div>
     <div class="actia-marker-icon ${markerColorClass}"></div>
     <div class="marker-label ${labelColorClass} ${selectedClass} flex justify-between items-center w-32 h-3">

         ${this.getCardinalDirectionHtmlIcon(vehicle.angle_current)}


       <div class="separator h-6 w-px bg-gray-300 mx-2"></div>
       <div>
         <i class="fas ${vehicleIconClass} vehicle-icon pr-2"></i>
       </div>
       <div class="truncate grow">
         ${(() => {
                  switch (displayMode) {
                    case 'driver':
                      return `<div class="truncate text-xs">${vehicle.drv1_firstname || 'N/A'
                        }</div>
                      <div class="truncate text-xs">${vehicle.drv1_lastname || 'N/A'
                        }</div>`;
                    case 'internalId':
                      return `<div class="truncate text-xs">${vehicle.vehicleInfo?.internalId || 'N/A'
                        }</div>`;
                    default: // 'plate'
                      return `<div class="truncate text-xs">${vehicle.plate}</div>`;
                  }
                })()}
       </div>
     </div>
   </div>
   `;

              //         const markerHtml = `
              //           <div class="custom-marker-icon">
              //             <div class="marker-shadow"></div>
              //             <div class="marker-icon ${markerColorClass}"></div>
              //             <div class="marker-label ${labelColorClass} ${selectedClass}    w-32">
              //   <i class="fas ${vehicleIconClass} vehicle-icon pr-2 pl-2"></i>
              //  <div class="flex flex-col truncate max-w-[8rem]">
              //     ${showDriver
              //       ? `<div class="truncate ">${vehicle.drv1Firstname}</div>
              //          <div class="truncate">${vehicle.drv1Lastname}</div>`
              //       : `<div class="truncate">${plate}</div>`}
              //       </div>
              //   </div>
              //         <div class="marker-arrow " style="transform: rotate(${angle}deg);">
              //          <i class="fas fa-location-arrow"></i>
              //        </div>

              //           </div>
              //         `;

              marker.setIcon(
                L.divIcon({
                  className: 'custom-marker-icon',
                  html: markerHtml,
                  iconSize: [25, 41],
                  iconAnchor: [12, 41],
                  popupAnchor: [85, -25]
                })
              );
            });
          });
        }
        if (toogleClusterButton) {
          let isClusterGroupVisible = true; // Stato iniziale: il cluster group è visibile

          toogleClusterButton.addEventListener('click', () => {
            if (!this.map || !this.markerClusterGroup) {
              console.warn(
                'La mappa o il markerClusterGroup non sono inizializzati.'
              );
              return;
            }

            if (isClusterGroupVisible) {
              // Rimuovi il cluster group dalla mappa
              this.map.removeLayer(this.markerClusterGroup);

              // Aggiungi tutti i marker individualmente alla mappa
              Object.values(this.markersMap).forEach((marker) => {
                this.map?.addLayer(marker);
              });

              isClusterGroupVisible = false;
              toogleClusterButton.classList.add('bg-white'); // Aggiungi una classe per indicare lo stato
              toogleClusterButton.style.backgroundColor = '#ffffff'; // Rimuovi evidenziazione
            } else {
              // Rimuovi tutti i marker individuali dalla mappa
              Object.values(this.markersMap).forEach((marker) => {
                this.map?.removeLayer(marker);
              });

              // Aggiungi il cluster group alla mappa
              this.map.addLayer(this.markerClusterGroup);

              isClusterGroupVisible = true;
              toogleClusterButton.classList.remove('bg-white'); // Rimuovi la classe per indicare lo stato
              toogleClusterButton.style.backgroundColor = mainColor; // Aggiungi evidenziazione
            }
          });
        }

        if (activateReports) {
          this.activateRepo = false;
          activateReports.addEventListener('click', () => {
            if (!this.activateRepo) {
              // Abilita i report con caricamento ottimizzato
              this.enableTrafficReports();
              this.activateRepo = true;
              activateReports.classList.remove('bg-white');
              activateReports.style.backgroundColor = mainColor;
            } else {
              // Disabilita i report e pulisce tutto
              this.disableTrafficReports();
              this.activateRepo = false;
              activateReports.classList.add('bg-white');
              activateReports.style.backgroundColor = '#ffffff';
            }
          });
        }

        if (routeCalculation) {
          // Tieni traccia dello stato della finestra di ricerca
          let isRouteSearchOpen = false;

          routeCalculation.addEventListener('click', () => {
            // Inverti lo stato solo quando si clicca
            const newState = !isRouteSearchOpen;

            if (newState !== isRouteSearchOpen) {
              isRouteSearchOpen = newState;

              if (isRouteSearchOpen) {
                routeCalculation.classList.remove('bg-white');
                routeCalculation.style.backgroundColor = mainColor;
                this.openSearchRoute.emit(true);
              } else {
                routeCalculation.classList.add('bg-white');
                routeCalculation.style.backgroundColor = '#ffffff';
                this.openSearchRoute.emit(false);
              }

              console.log(`Stato ricerca percorso cambiato: ${isRouteSearchOpen ? 'aperto' : 'chiuso'}`);
            } else {
              console.log('Stato ricerca percorso non cambiato, nessun evento emesso');
            }
          });

          if (isRouteSearchOpen) {
            routeCalculation.classList.remove('bg-white');
            routeCalculation.style.backgroundColor = mainColor;
          } else {
            routeCalculation.classList.add('bg-white');
            routeCalculation.style.backgroundColor = '#ffffff';
          }

          // Emetti lo stato iniziale solo se necessario (per esempio, al primo caricamento)
          // Se lo stato iniziale è già quello desiderato, potresti voler omettere questa emissione
          this.openSearchRoute.emit(isRouteSearchOpen);
        }

        if (pdfPrintButton) {
          pdfPrintButton.addEventListener('click', () => {
            console.log(this.markersMap);

            // Cambia il colore del bottone a cyan per indicare il caricamento
            pdfPrintButton.classList.remove('bg-white');
            pdfPrintButton.style.backgroundColor = mainColor;
            console.log('PDF Print button clicked');
            console.log('Instance ID:', instanceId);
            if (instanceId === 'default' || instanceId === 'actiaMap') {

              this.printVechiclePDF();

            } else if (instanceId === 'map-journey') {
              // PDF per journey - esporta solo dati del journey
              this.printJourneyPDF();
            }

            // Aspetta un po' prima di ripristinare il colore (tempo stimato per l'export)
            setTimeout(() => {
              pdfPrintButton.classList.add('bg-white');
              pdfPrintButton.style.backgroundColor = '#ffffff';
            }, 2000); // 2 secondi - puoi regolare in base alle tue esigenze
          });
        }
        if (prohibitions) {
          prohibitions.addEventListener('click', () => {
            this.prohibitionsActive = !this.prohibitionsActive;

            if (this.prohibitionsActive) {
              this.enableVehicleRestrictions();
              prohibitions.style.backgroundColor = mainColor;
              prohibitions.classList.remove('bg-white');
              console.log('Restrizioni per mezzi pesanti attivate');
            } else {
              this.disableVehicleRestrictions();
              prohibitions.style.backgroundColor = '#ffffff';
              prohibitions.classList.add('bg-white');
              console.log('Restrizioni per mezzi pesanti disattivate');
            }
          });
        }

        if (tutorial) {
          tutorial.addEventListener('click', () => {
            this.tutorialActive.emit(true);

          });
        }

        if (weatherButton) {
          // L'event listener verrà aggiunto dopo che il controllo meteo è stato inizializzato
          // console.log('Bottone weather trovato, event listener verrà aggiunto dopo inizializzazione controllo meteo');
        }

        if (fieldLabelsButton) {
          // Tre stati: 0 = campi visibili (stato iniziale), 1 = campi + etichette, 2 = tutto nascosto
          let fieldDisplayState = 0;

          // Imposta lo stato iniziale (campi visibili, etichette nascoste)
          this.showAllFields();
          this.hideFieldLabels();
          fieldLabelsButton.classList.remove('bg-white');
          fieldLabelsButton.style.backgroundColor = mainColor;

          fieldLabelsButton.addEventListener('click', () => {
            const iconElement = fieldLabelsButton.querySelector('i');

            // Cicla tra i 3 stati
            fieldDisplayState = (fieldDisplayState + 1) % 3;

            switch (fieldDisplayState) {
              case 0: // Stato 1: Solo campi visibili
                this.showAllFields();
                this.hideFieldLabels();
                fieldLabelsButton.classList.remove('bg-white');
                fieldLabelsButton.style.backgroundColor = mainColor;
                if (iconElement) {
                  iconElement.className = 'fa-solid fa-wheat-awn text-gray-800 text-lg';
                }
                console.log('Campi agricoli mostrati (senza etichette)');
                break;

              case 1: // Stato 2: Campi + etichette
                this.showAllFields();
                this.showFieldLabels();
                fieldLabelsButton.classList.remove('bg-white');
                fieldLabelsButton.style.backgroundColor = mainColor;
                if (iconElement) {
                  iconElement.className = 'fa-solid fa-tags text-gray-800 text-lg';
                }
                console.log('Campi agricoli mostrati con etichette');
                break;

              case 2: // Stato 3: Tutto nascosto
                this.hideAllFields();
                this.hideFieldLabels();
                fieldLabelsButton.classList.add('bg-white');
                fieldLabelsButton.style.backgroundColor = '#ffffff';
                if (iconElement) {
                  iconElement.className = 'fa-solid fa-eye-slash text-gray-800 text-lg';
                }
                console.log('Campi agricoli e etichette nascosti');
                break;
            }
          });
        }

        if (geofenceButton) {
          geofenceButton.addEventListener('click', () => {
            this.geofenceToggle();
          });
        }

        if (fullScreenButton) {
          let isFullScreen = false;
          document.addEventListener('fullscreenchange', () => {
            isFullScreen = !!document.fullscreenElement;

            if (isFullScreen) {
              fullScreenButton.style.backgroundColor = mainColor;
              fullScreenButton.classList.remove('bg-white');

              const iconElement = fullScreenButton.querySelector('i');
              if (iconElement) {
                iconElement.className = 'fas fa-compress text-gray-800 text-lg';
              }
            } else {
              fullScreenButton.style.backgroundColor = '#ffffff';
              fullScreenButton.classList.add('bg-white');

              const iconElement = fullScreenButton.querySelector('i');
              if (iconElement) {
                iconElement.className = 'fas fa-maximize text-gray-800 text-lg';
              }
            }
          });

          fullScreenButton.addEventListener('click', () => {
            const element = document.documentElement;

            if (!isFullScreen) {
              // Attiva la modalità a tutto schermo
              element.requestFullscreen().catch((err) => {
                console.error(
                  `Errore durante l'attivazione della modalità a tutto schermo: ${err.message}`
                );
              });
            } else {
              // Disattiva la modalità a tutto schermo
              document.exitFullscreen().catch((err) => {
                console.error(
                  `Errore durante l'uscita dalla modalità a tutto schermo: ${err.message}`
                );
              });
            }
            // Non aggiornare isFullScreen qui, sarà aggiornato dall'event listener
          });
        }
      });

      return div;
    };

    toolbarControl.addTo(this.map);
  }

  getCardinalDirection(angle: number): { icon: string; text: string } {
    if (angle === undefined || angle === null) {
      return { icon: 'help_outline', text: 'N/A' };
    }
    var lblNorth = this.translateService.instant('mapPage.north');
    var lblNorthEast = this.translateService.instant('mapPage.north_east');
    var lblEast = this.translateService.instant('mapPage.east');
    var lblSouthEast = this.translateService.instant('mapPage.south_east');
    var lblSouth = this.translateService.instant('mapPage.south');
    var lblSouthWest = this.translateService.instant('mapPage.south_west');
    var lblWest = this.translateService.instant('mapPage.west');
    var lblNorthWest = this.translateService.instant('mapPage.north_west');
    var lblUnknown = this.translateService.instant('mapPage.unknown');

    if (angle >= 337.5 || angle < 22.5) {
      return { icon: 'north', text: lblNorth };
    } else if (angle >= 22.5 && angle < 67.5) {
      return { icon: 'north_east', text: lblNorthEast };
    } else if (angle >= 67.5 && angle < 112.5) {
      return { icon: 'east', text: lblEast };
    } else if (angle >= 112.5 && angle < 157.5) {
      return { icon: 'south_east', text: lblSouthEast };
    } else if (angle >= 157.5 && angle < 202.5) {
      return { icon: 'south', text: lblSouth };
    } else if (angle >= 202.5 && angle < 247.5) {
      return { icon: 'south_west', text: lblSouthWest };
    } else if (angle >= 247.5 && angle < 292.5) {
      return { icon: 'west', text: lblWest };
    } else if (angle >= 292.5 && angle < 337.5) {
      return { icon: 'north_west', text: lblNorthWest };
    }

    return { icon: 'help_outline', text: lblUnknown };
  }

  // Modifica il metodo per generare direttamente l'HTML dell'icona
  getCardinalDirectionHtmlIconText(angle: number): string {
    const direction = this.getCardinalDirection(angle);

    // Usa la classe material-icons direttamente nell'HTML
    return `<div style="display: flex; justify-content: space-between; align-items: center;" ><i class="material-icons" style="font-size: 18px; vertical-align: middle;">${direction.icon}</i> <div class="color: white">${direction.text}</div></div>`;
  }

  getCardinalDirectionHtmlIcon(angle: number): string {
    const direction = this.getCardinalDirection(angle);

    // Usa la classe material-icons direttamente nell'HTML
    return `<i class="material-icons" style="font-size: 18px; vertical-align: middle; color:black">${direction.icon}</i>`;
  }

  addBaseLayers(): void {
    if (!this.map) {
      console.error('La mappa non è stata inizializzata.');
      return;
    }

    // Verifica API Key Stadia
    if (!environment.keyStadia) {
    //  console.error('Stadia API Key non configurata in environment!');
      // Usa un layer di fallback se non c'è la chiave Stadia
      const osmLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap contributors',
        maxZoom: 20
      });
      osmLayer.addTo(this.map);
//      console.log('Aggiunto layer OpenStreetMap come fallback');
      return;
    }

  //  console.log('Stadia API Key presente:', environment.keyStadia ? 'SI' : 'NO');

    // Crea layer di fallback
    const osmLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors',
      maxZoom: 19
    });

    const esriSatelliteLayer = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
      attribution: 'Tiles © Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
      maxZoom: 18  // Limite reale di Esri Satellite
    });

    // Stadia Maps layers
    const stadiaAlidadeSatelliteLayer = L.tileLayer(
      `https://tiles.stadiamaps.com/tiles/alidade_satellite/{z}/{x}/{y}{r}.png?api_key=${environment.keyStadia}`,
      {
        attribution: attribution,
        minZoom: 2,
        maxZoom: 20  // Aumentato a 22 per zoom più dettagliato
      }
    );

    const stadiaOsmBrightLayer = L.tileLayer(
      `https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png?api_key=${environment.keyStadia}`,
      {
        attribution: attribution,
        minZoom: 2,
        maxZoom: 20  // Aumentato a 22 per zoom più dettagliato
      }
    );

    // Variabile per contare errori di caricamento
    let stadiaErrorCount = 0;
    const maxErrors = 3;
    let currentActiveLayer = stadiaAlidadeSatelliteLayer;

    // Funzione per passare al fallback
    const switchToFallback = () => {
      if (!this.map) return;
      console.warn('Troppe tile Stadia fallite, passaggio al fallback...');
      this.map.removeLayer(currentActiveLayer);
      esriSatelliteLayer.addTo(this.map);
      currentActiveLayer = esriSatelliteLayer;
    };

    // Aggiungi il layer base predefinito alla mappa (Stadia Satellite)
    console.log('Aggiungendo layer Stadia Satellite come default...');
    stadiaAlidadeSatelliteLayer.addTo(this.map);

    // Verifica se il layer è stato aggiunto
    let layerCount = 0;
    this.map.eachLayer(() => layerCount++);
    console.log('Layer aggiunto. Numero totale di layer:', layerCount);

    // Aggiungi event listener per controllare il caricamento delle tile
    stadiaAlidadeSatelliteLayer.on('tileload', () => {
      // Reset del contatore errori quando una tile carica con successo
      stadiaErrorCount = 0;
    });

    stadiaAlidadeSatelliteLayer.on('tileerror', (error) => {
      console.error('Errore caricamento tile Stadia Satellite:', error);
      stadiaErrorCount++;
      if (stadiaErrorCount >= maxErrors && currentActiveLayer === stadiaAlidadeSatelliteLayer) {
        switchToFallback();
      }
    });

    // Event listener per Stadia OSM Bright
    stadiaOsmBrightLayer.on('tileload', () => {
      stadiaErrorCount = 0;
    });

    stadiaOsmBrightLayer.on('tileerror', (error) => {
      console.error('Errore caricamento tile Stadia OSM:', error);
      stadiaErrorCount++;
      if (stadiaErrorCount >= maxErrors && currentActiveLayer === stadiaOsmBrightLayer) {
        if (!this.map) return;
        console.warn('Troppe tile Stadia OSM fallite, passaggio a OpenStreetMap...');
        this.map.removeLayer(currentActiveLayer);
        osmLayer.addTo(this.map);
        currentActiveLayer = osmLayer;
      }
    });

    // Definisci i layer base per il controllo layer (inclusi i fallback)
    const baseLayers = {
      'Stadia Satellite': stadiaAlidadeSatelliteLayer,
      'Stadia OSM Bright': stadiaOsmBrightLayer,
      'Esri Satellite (Fallback)': esriSatelliteLayer,
      'OpenStreetMap (Fallback)': osmLayer
    };

    // Aggiungi il controllo dei layer
    const layerControl = L.control
      .layers(baseLayers, {}, { position: 'bottomright' })
      .addTo(this.map);

    // Gestisci il cambio di layer per adattare il maxZoom
    this.map.on('baselayerchange', (e: any) => {
      const layerName = e.name;
      let newMaxZoom = 20; // Default per Stadia Maps

      if (layerName.includes('Esri')) {
        newMaxZoom = 18; // Limite per Esri
      } else if (layerName.includes('OpenStreetMap')) {
        newMaxZoom = 19; // Limite per OSM
      }

      // Aggiorna il maxZoom della mappa
      this.map!.setMaxZoom(newMaxZoom);

      // Se lo zoom attuale è maggiore del nuovo limite, riduci
      if (this.map!.getZoom() > newMaxZoom) {
        this.map!.setZoom(newMaxZoom);
      }

      console.log(`Layer cambiato a: ${layerName}, nuovo maxZoom: ${newMaxZoom}`);
    });
  }

  /**
   * Inizializza i controlli di disegno per geofence
   */
  private initializeDrawingControls(): void {
    if (!this.map) {
      console.warn('Mappa non inizializzata per i controlli di disegno');
      return;
    }

    // Aggiungi il layer delle forme editabili alla mappa
    this.map.addLayer(this.editableLayers);

    // Configura le opzioni per il controllo di disegno
    const drawControl = new L.Control.Draw({
      position: 'topright',
      draw: {
        polygon: {
          allowIntersection: false,
          drawError: {
            color: '#e1e100',
            message: '<strong>Errore:</strong> I bordi del poligono non possono intersecarsi!'
          },
          shapeOptions: {
            color: '#FF0000',
            weight: 3,
            opacity: 0.8,
            fillOpacity: 0.4
          }
        },
        rectangle: {
          shapeOptions: {
            color: '#FF0000',
            weight: 3,
            opacity: 0.8,
            fillOpacity: 0.4
          }
        },
        polyline: {
          shapeOptions: {
            color: '#FF0000',
            weight: 3,
            opacity: 0.8
          }
        },
        circle: false, // Disabilita i cerchi
        marker: false, // Disabilita i marker
        circlemarker: false // Disabilita i circle marker
      },
      edit: {
        featureGroup: this.editableLayers,
        remove: true
      }
    });

    this.drawControl = drawControl;
    this.map.addControl(drawControl);

    // Event listener per quando viene creata una forma
    this.map.on(L.Draw.Event.CREATED, (event: any) => {
      const layer = event.layer;
      this.editableLayers.addLayer(layer);
      console.log('Forma disegnata:', event.layerType, layer);

      // Emit eventi specifici in base al tipo di forma
      if (event.layerType === 'polygon') {
        this.onPolygonCreated.emit(layer);
      }
    });

    // Event listener per quando viene modificata una forma
    this.map.on(L.Draw.Event.EDITED, (event: any) => {
      console.log('Forme modificate:', event.layers);
      this.onShapeEdited.emit(event.layers);
    });

    // Event listener per quando viene eliminata una forma
    this.map.on(L.Draw.Event.DELETED, (event: any) => {
      console.log('Forme eliminate:', event.layers);
      this.onShapeDeleted.emit(event.layers);
    });

    console.log('Controlli di disegno inizializzati');
  }

  /**
   * Attiva la modalità di disegno poligono
   * @param color Colore da utilizzare per il poligono (default: '#FF0000')
   */
  public startPolygonDrawing(color: string = '#FF0000'): void {
    if (!this.map || !this.drawControl) {
      console.warn('Mappa o controlli di disegno non inizializzati');
      return;
    }

    // Crea opzioni personalizzate con il colore specificato
    const customPolygonOptions = {
      allowIntersection: false,
      drawError: {
        color: '#e1e100',
        message: '<strong>Errore:</strong> I bordi del poligono non possono intersecarsi!'
      },
      shapeOptions: {
        color: color,
        weight: 3,
        opacity: 0.8,
        fillOpacity: 0.4
      }
    };

    // Attiva lo strumento di disegno poligono con le opzioni personalizzate
    const drawPolygonHandler = new (L.Draw as any).Polygon(this.map as any, customPolygonOptions);
    drawPolygonHandler.enable();
    console.log(`Modalità disegno poligono attivata con colore: ${color}`);
  }



  /**
   * Disabilita tutti i modi di disegno
   */
  public stopDrawing(): void {
    if (!this.map) {
      return;
    }

    // Disabilita tutti i handler di disegno
    this.map.eachLayer((layer: any) => {
      if (layer._drawingHandler) {
        layer._drawingHandler.disable();
      }
    });
    console.log('Modalità disegno disattivata');
  }

  /**
   * Ottiene il layer group delle forme editabili
   */
  public getEditableLayers(): L.FeatureGroup {
    return this.editableLayers;
  }

  /**
   * Rimuove tutte le forme disegnate
   */
  public clearDrawnShapes(): void {
    this.editableLayers.clearLayers();
    console.log('Tutte le forme disegnate sono state rimosse');
  }

  /**
   * Inizializza il controllo meteo (chiamato una sola volta)
   */
  private initializeWeatherControl(): void {
    if (!this.map) {
      console.error('Mappa non disponibile per inizializzazione controllo meteo');
      return;
    }

    try {
      // console.log('Inizializzazione controllo meteo...');
      this.addWeatherControl();
      // console.log('Controllo meteo inizializzato con successo');
    } catch (error) {
      console.error('Errore nell\'inizializzazione del controllo meteo:', error);
    }
  }

  /**
   * Pulisce tutti i layer meteo attivi dalla mappa
   */
  private clearActiveWeatherLayers(): void {
    if (!this.map) {
      return;
    }

    // console.log('Rimozione layer meteo attivi...');

    // Rimuovi tutti i layer meteo dalla mappa
    const self = this;
    this.map.eachLayer(function (layer: any) {
      if (layer._url === self.weatherLayerEndpoint ||
          layer._url === self.weatherTsUrlEndpoint ||
          layer._url === self.weatherOpacityUrl) {
        self.map!.removeLayer(layer);
        // console.log('Layer meteo rimosso');
      }
    });

    // Reset delle selezioni nella toolbar
    const toolbar = document.getElementsByClassName("weather-toolbar-div")[0] as HTMLElement;
    if (toolbar) {
      for (let i = 0; i < toolbar.children.length; i++) {
        toolbar.children[i].children[0]?.classList.remove('aft-leaflet-toolbar-item__active');
        toolbar.children[i].children[1]?.classList.remove('aft-leaflet-toolbar-item__active');
        toolbar.children[i].setAttribute('data-selected', 'false');
      }
    }

    // Reset delle proprietà
    this.selectedWeatherLayers = [];
    this.globalLayerId = 0;

    // Nascondi la scala cromatica
    if (this.scaleWrapper) {
      this.scaleWrapper.classList.add('hidden');
    }

    // console.log('Layer meteo attivi rimossi');
  }

  /**
   * Determina l'icona da visualizzare in base al tipo di veicolo
   * @param vehicle Il veicolo di cui determinare l'icona
   * @returns La classe CSS dell'icona di FontAwesome da utilizzare
   */
  vehicleIconClass(vehicle: any): string {
    // Estrai il tipo di veicolo, gestendo i possibili valori null/undefined
    const vehicleType = vehicle?.vehicleInfo?.vehicleType?.idVehicleCategory;

    // Applica la stessa logica delle condizioni nel template
    if (vehicleType === 2 || vehicleType === 4 || vehicleType === 5) {
      return 'fa-solid fa-truck';
    } else if (vehicleType === 6 || vehicleType === 7 || vehicleType === 8) {
      return 'fa-solid fa-trailer';
    } else if (vehicleType === 3) {
      return 'fa-solid fa-trailer';
    } else if (vehicleType === 1) {
      return 'fa-solid fa-truck-pickup';
    }

    // Valore predefinito se nessun tipo corrisponde o se il tipo è undefined
    //return 'fa-solid fa-question';
    return 'fa-solid ';
  }

  /**
   * Translates the vehicle status code into a readable text
   * @param status Vehicle status code
   * @returns Translated status text
   */
  translateVehicleStatus(status: string): string {
    var lblMoving = this.translateService.instant('mapPage.moving');
    var lblParked = this.translateService.instant('mapPage.parked');
    var lblIdle = this.translateService.instant('mapPage.idle');
    var lblUnknown = this.translateService.instant('mapPage.unknown');
    var lblNotConnected = this.translateService.instant('mapPage.notConnected');

    switch (status) {
      case 'MOVING':
        return lblMoving;
      case 'PARKED':
        return lblParked;
      case 'IDLE':
        return lblIdle;
      case 'UNKNOWN':
        return lblUnknown;
      case 'NOTCONNECTED':
        return lblNotConnected;
      default:
        return status || 'N/A';
    }
  }

  translateJourneyStatus(status: string) {
    if (!status) return 'STATUS(N/D)';

    if (status === 'IN_PROGRESS') {
      return this.translateService.instant('mapPage.status_in_progress');
    } else if (status === 'CLOSED') {
      return this.translateService.instant('mapPage.status_closed');
    }
  }

  // public formatNumber(
  //   value: number | null | undefined,
  //   decimals: number = 2
  // ): string {
  //   if (value === null || value === undefined) {
  //     return 'N/A';
  //   }

  //   // Formatta con separatore di migliaia e decimali in formato italiano
  //   return new Intl.NumberFormat('it-IT', {
  //     minimumFractionDigits: 0,
  //     maximumFractionDigits: decimals
  //   }).format(value);
  // }

  // Metodo per gestire la selezione di partenza/arrivo
  setRoutePoint(type: 'start' | 'end', latlng: L.LatLng) {
    if (this.tempMarker) {
      this.map?.removeLayer(this.tempMarker);
      this.tempMarker = null;
    }
    // Rimuovi marker precedente se esiste
    if (type === 'start' && this._routeStartMarker) {
      this.map?.removeLayer(this._routeStartMarker);
      this._routeStartMarker = null;
    }
    if (type === 'end' && this._routeEndMarker) {
      this.map?.removeLayer(this._routeEndMarker);
      this._routeEndMarker = null;
    }

    // Genera un ID univoco per questo punto
    const pointId = `route-point-${type}`;
    // Crea marker
    const color = type === 'start' ? '#1976d2' : '#3ea463';
    const label = type === 'start' ? 'P' : 'A';
    const marker = L.marker(latlng, {
      icon: L.divIcon({
        html: `<svg id="${pointId}" xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <circle cx="20" cy="20" r="18" fill="${color}" stroke="#fff" stroke-width="3"/>
        <text x="50%" y="54%" text-anchor="middle" fill="#fff" font-size="20" font-family="Arial" dy=".3em">${label}</text>
      </svg>`,
        className: pointId,
        iconSize: [40, 40],
        iconAnchor: [20, 40]
      }),
      zIndexOffset: 1000
    }).addTo(this.map!);

    if (type === 'start') {
      this._routeStartMarker = marker;
    } else {
      this._routeEndMarker = marker;
    }

    // Emetti evento per il componente padre (ad esempio per aggiornare gli input di ricerca)
    this.onMapRightClick.emit({ type, latlng });
  }

  // Metodi per impostare e cancellare i punti
  setRouteStartPoint(lat: number, lng: number, label: string = '') {
    this.selectedStartAddressSubject.next({ lat, lng, label: label });

  }

  setRouteEndPoint(lat: number, lng: number, label: string = '') {
    this.selectedEndAddressSubject.next({ lat, lng, label: label });

  }
  clearRouteStartPoint() {
    // Rimuovi marker precedente se esiste
    if (this._routeStartMarker) {
      this.map?.removeLayer(this._routeStartMarker);
      this._routeStartMarker = null;
    }
    this.selectedStartAddressSubject.next(null);
  }

  clearRouteEndPoint() {

    if (this._routeEndMarker) {
      this.map?.removeLayer(this._routeEndMarker);
      this._routeEndMarker = null;
    }
    this.selectedEndAddressSubject.next(null);
  }

  // In ActiaMapService
  deleteRoutePoints() {
    // Rimuovi marker temporaneo se esiste
    if (this.tempMarker) {
      this.map?.removeLayer(this.tempMarker);
      this.tempMarker = null;
    }




    // Pulisci i punti nel servizio
    this.clearRouteStartPoint();
    this.clearRouteEndPoint();

    // Rimuovi tutte le polyline presenti sulla mappa
    if (this.map) {
      this.map.eachLayer(layer => {
        // Verifica se il layer è una polyline
        if (layer instanceof L.Polyline && !(layer instanceof L.Polygon)) {
          // Escludiamo i polygon che sono tecnicamente anche polyline
          this.map?.removeLayer(layer);
          console.log('Rimossa polyline dalla mappa');
        }
      });
    }



    // Chiudi eventuali popup aperti
    this.map?.closePopup();


  }


  printVechiclePDF() {
    console.log('printVechiclePDF called');
    let consLabel = this.utilsService.getConsLabel();
    let distanceLabel = this.utilsService.getDistanceLabel();
    let volumeLabel = this.utilsService.getVolumeLabel();
    let listTable: any = [];

    // Estrai i dati dei veicoli da markersMap
    const vehiclesData: IotAsset[] = [];
    Object.values(this.markersMap).forEach((marker: any) => {
      if (marker.vehicleData) {
        vehiclesData.push(marker.vehicleData);
      }
    });

    // Parametri di intestazione
    let parameter = ['',
      this.translateService.instant('global.vehicles') + ': ' + vehiclesData.length
      // this.translateService.instant('mapPage.exportDate') + ': ' + new Date().toLocaleString()
    ];

    this.exportPDFService.pdfOrientationSet('l');
    this.exportPDFService.dataHeaderSet(parameter);
    this.exportPDFService.fileNameSet('Vehicles_Map_Export');
    this.exportPDFService.titlePDfSet(this.translateService.instant('global.titleListVehic'));

    // Colonne per la tabella dei veicoli
    let colVehicles = [
      { field: 'plate', header: this.translateService.instant('global.plate') },
      { field: 'driver', header: this.translateService.instant('global.driver') },
      { field: 'status', header: this.translateService.instant('mapPage.state') },
      { field: 'currentPosition', header: this.translateService.instant('mapPage.currentPosition') },
      { field: 'lastUpdate', header: this.translateService.instant('mapPage.lastUpdate') },
      { field: 'todayDistance', header: this.translateService.instant('mapPage.todayDistance') },
      { field: 'fuelConsumption', header: this.translateService.instant('mapPage.todayConsumption') },
      { field: 'fuelLevel', header: this.translateService.instant('mapPage.fuelLevel1') }
    ];

    // Dati per la tabella
    let dataTableVehicles: any = [];
    for (let vehicle of vehiclesData) {
      const driver = (vehicle.drv1_firstname || '') + ' ' + (vehicle.drv1_lastname || '');
      const lastUpdate = vehicle.updated_at
        ? this.datePipe.transform(vehicle.updated_at, 'dd/MM/yyyy HH:mm:ss')
        : 'N/A';
      const todayDistance = vehicle.total_distance_km != null
        ? `${this.utlService.formatNumber(vehicle.total_distance_km)} ${distanceLabel}`
        : 'N/A';
      const fuelConsumption = vehicle.total_fuel_consumed_liters != null
        ? `${this.utlService.formatNumber(vehicle.total_fuel_consumed_liters, 2)} ${volumeLabel}`
        : 'N/A';
      const fuelLevel = vehicle.fuel_level_1 != null
        ? `${vehicle.fuel_level_1}%`
        : 'N/A';

      dataTableVehicles.push({
        plate: vehicle.plate || 'N/A',
        driver: driver.trim() || 'N/A',
        status: this.translateVehicleStatus(vehicle.vehicle_status),
        currentPosition: vehicle.addressCurrent || 'N/A',
        lastUpdate: lastUpdate,
        todayDistance: todayDistance,
        fuelConsumption: fuelConsumption,
        fuelLevel: fuelLevel
      });
    }

    listTable.push({
      headerCols: colVehicles,
      dataTable: dataTableVehicles
    });

    try {
      if (this.map) {
        this.exportPDFService.addMapImageSet(this.map.getContainer().id);
      }
    } catch (error) {
      console.warn('Errore nella cattura CSS (ignorato):', error);
      // Continua senza l'immagine della mappa
    }
    this.exportPDFService.listTablesSet(listTable);
    this.exportPDFService.exportPDF();
  }

  printJourneyPDF() {
    console.log('printJourneyPDF called');
    let consLabel = this.utilsService.getConsLabel();
    let distanceLabel = this.utilsService.getDistanceLabel();
    let volumeLabel = this.utilsService.getVolumeLabel();
    let listTable: any = [];

    // Ottieni la lista completa dei journey con indirizzi risolti
     let journeys;
    // if (this.HJourneyService.getActivePage() === 'actia-journey') {
    //   journeys = this.HJourneyService.getJourneysList() || [];
    // } else {
    //  // journeys = this.journeyService.currentJourneyList;
    // }

    console.log('Journey list per PDF:', journeys);

    if (!journeys || journeys.length === 0) {
      console.warn('Nessun journey disponibile per l\'export PDF');
      return;
    }

    // Ordina i journey per trip_id in ordine decrescente
    const sortedJourneys = journeys.sort((a, b) => b.trip_id - a.trip_id);

    // Ottieni la targa dal primo journey (assumendo che tutti abbiano la stessa targa)
    const plate = sortedJourneys[0]?.plate || 'N/A';

    // Parametri di intestazione con la targa
    let parameter = [
      this.translateService.instant('global.plate') + ': ' + plate,
      this.translateService.instant('global.journeys') + ': ' + sortedJourneys.length,
      // this.translateService.instant('mapPage.exportDate') + ': ' + new Date().toLocaleString()
    ];

    this.exportPDFService.pdfOrientationSet('l');
    this.exportPDFService.dataHeaderSet(parameter);
    this.exportPDFService.fileNameSet(`Journeys_${plate}_Export`);
    this.exportPDFService.titlePDfSet(this.translateService.instant('global.journey'));

    // Colonne per la tabella dei journey - aggiungi trip_id come primo campo
    let colJourneys = [
      { field: 'tripId', header: "#" },
      { field: 'driver', header: this.translateService.instant('global.driver') },
      { field: 'startTime', header: this.translateService.instant('mapPage.startTime') },
      { field: 'endTime', header: this.translateService.instant('global.endTime') },
      { field: 'duration', header: this.translateService.instant('mapPage.duration') },
      { field: 'distance', header: this.translateService.instant('mapPage.distance') },
      { field: 'fuelConsumption', header: this.translateService.instant('mapPage.todayConsumption') },
      { field: 'fuelEfficiency', header: this.translateService.instant('mapPage.averageConsumption') },
      { field: 'status', header: this.translateService.instant('mapPage.state') },
      { field: 'addressStart', header: this.translateService.instant('mapPage.departure') },
      { field: 'addressEnd', header: this.translateService.instant('mapPage.arrival') }
    ];

    // Dati per la tabella
    let dataTableJourneys: any = [];
    for (let journey of sortedJourneys) {
      const startTime = journey.start_time
        ? this.datePipe.transform(journey.start_time, 'dd/MM/yyyy HH:mm:ss')
        : 'N/A';
      const endTime = journey.end_time
        ? this.datePipe.transform(journey.end_time, 'dd/MM/yyyy HH:mm:ss')
        : 'N/A';
      const distance = journey.total_km != null
        ? `${this.utlService.formatNumber(journey.total_km)} ${distanceLabel}`
        : 'N/A';
      const fuelConsumption = journey.total_fuel_consumed != null
        ? `${this.utlService.formatNumber(journey.total_fuel_consumed, 2)} ${volumeLabel}`
        : 'N/A';
      const fuelEfficiency = journey.fuel_efficiency != null
        ? `${this.utlService.formatNumber(journey.fuel_efficiency, 2)} ${distanceLabel}/${volumeLabel}`
        : 'N/A';

      dataTableJourneys.push({
        tripId: journey.trip_id || 'N/A',
        driver: journey.drv1 || 'N/A',
        startTime: startTime,
        endTime: endTime,
        duration: journey.journey_duration || 'N/A',
        distance: distance,
        fuelConsumption: fuelConsumption,
        fuelEfficiency: fuelEfficiency,
        status: this.translateJourneyStatus(journey.status),
        addressStart: journey.addressStart || 'N/A',
        addressEnd: journey.addressEnd || 'N/A'
      });
    }

    listTable.push({
      headerCols: colJourneys,
      dataTable: dataTableJourneys
    });

    try {
      if (this.map) {
        this.exportPDFService.addMapImageSet(this.map.getContainer().id);
      }
    } catch (error) {
      console.warn('Errore nella cattura CSS (ignorato):', error);
      // Continua senza l'immagine della mappa
    }
    this.exportPDFService.listTablesSet(listTable);
    this.exportPDFService.exportPDF();
  }

  /**
   * Abilita le restrizioni per i mezzi pesanti sulla mappa
   * NOTA: Funzionalità non disponibile con Stadia Maps, richiede implementazione alternativa
   */
  enableVehicleRestrictions(): void {
    if (!this.map) {
      console.error('La mappa non è stata inizializzata.');
      return;
    }

    console.warn('Le restrizioni per mezzi pesanti non sono supportate con Stadia Maps.');
    console.log('Funzionalità restrizioni non implementata - richiede servizio esterno o overlay personalizzato');

    // TODO: Implementare overlay personalizzato per restrizioni veicoli
    // Opzioni possibili:
    // 1. Usare un servizio di routing che supporta restrizioni (es. GraphHopper, OSRM)
    // 2. Caricare dati di restrizioni da una fonte esterna come overlay
    // 3. Integrare con un servizio di geocoding che fornisce informazioni sulle restrizioni
  }

  /**
   * Disabilita le restrizioni per i mezzi pesanti sulla mappa
   */
  disableVehicleRestrictions(): void {
    if (!this.map) {
      console.error('La mappa non è stata inizializzata.');
      return;
    }

    console.log('Restrizioni veicoli disabilitate (nessuna azione richiesta con Stadia Maps)');

    // Con Stadia Maps non c'è nulla da disabilitare specificamente per le restrizioni
    // Il layer base rimane quello standard
  }

  /**
   * Abilita i report di traffico con ottimizzazioni per le performance
   */
  enableTrafficReports(): void {
    if (!this.map) {
      console.error('La mappa non è stata inizializzata.');
      return;
    }

    console.log('Abilitazione report di traffico ottimizzata...');

    // Carica i dati di traffico solo se necessario
    const now = Date.now();
    if (now - this.lastTrafficUpdate > this.TRAFFIC_UPDATE_INTERVAL) {
      this.loadTrafficDataOptimized();
      this.lastTrafficUpdate = now;
    }

    // Imposta aggiornamento automatico con intervallo
    if (!this.trafficUpdateInterval) {
      this.trafficUpdateInterval = setInterval(() => {
        if (this.activateRepo && this.map) {
          const zoom = this.map.getZoom() ?? 0;
          if (zoom >= 11) { // Carica solo a zoom alti
            this.loadTrafficDataOptimized();
          }
        }
      }, this.TRAFFIC_UPDATE_INTERVAL);
    }

    // Event listener per zoom - pulisce i dati a zoom bassi
    this.map.on('zoomend', this.handleTrafficZoomChange.bind(this));

    console.log('Report di traffico abilitati con ottimizzazioni');
  }

  /**
   * Disabilita i report di traffico e pulisce tutte le risorse
   */
  disableTrafficReports(): void {
    console.log('Disabilitazione report di traffico...');

    // Ferma tutti gli aggiornamenti automatici
    if (this.trafficUpdateInterval) {
      clearInterval(this.trafficUpdateInterval);
      this.trafficUpdateInterval = null;
    }

    // Annulla richieste in corso
    if (this.trafficAbortController) {
      this.trafficAbortController.abort();
      this.trafficAbortController = null;
    }

    // Pulisci tutti i marker e dati
    this.clearTrafficFlow();
    this.clearIncidents();

    // Reset del centro per forzare ricaricamento alla prossima attivazione
    this.lastCenterLatLng = null;
    this.lastTrafficUpdate = 0;

    // Rimuovi event listener
    if (this.map) {
      this.map.off('zoomend', this.handleTrafficZoomChange);
    }

    console.log('Report di traffico disabilitati e risorse pulite');
  }

  /**
   * Caricamento ottimizzato dei dati di traffico
   */
  private loadTrafficDataOptimized(): void {
    console.warn('Funzionalità traffico ottimizzata disabilitata: richiede HERE Maps API non più disponibile');
    console.log('TODO: Implementare alternativa per dati traffico ottimizzati con provider compatibile con Stadia Maps');

    return;
  }

  /**
   * Disegna il traffico con ottimizzazioni
   */
  private drawTrafficFlowOptimized(flows: any[]): void {
    this.clearTrafficFlow();

    // Limita il numero di marker per evitare sovraccarico
    const limitedFlows = flows
      .filter(f => f.location?.shape?.links?.length > 0)
      .slice(0, this.MAX_TRAFFIC_MARKERS);

    for (let f of limitedFlows) {
      const jamFactor = f.currentFlow?.jamFactor || 0;

      // Mostra solo traffico significativo
      if (jamFactor < 2) continue;

      const color = jamFactor > 7 ? '#ff0000' : jamFactor > 4 ? '#ff8800' : '#ffff00';
      const weight = Math.max(2, Math.min(6, jamFactor));

      const allPoints = f.location.shape.links.flatMap((link: any) => link.points);
      if (allPoints?.length > 1) {
        const coords = allPoints.map((point: any) => [point.lat, point.lng]);

        const polyline = L.polyline(coords, {
          color: color,
          weight: weight,
          opacity: 0.7
        }).addTo(this.map!);

        this.trafficMarkers.push(polyline);
      }
    }

    console.log(`Traffico disegnato: ${limitedFlows.length} elementi`);
  }

  /**
   * Disegna gli incidenti con ottimizzazioni
   */
  private drawIncidentsOptimized(incidents: any[]): void {
    this.clearIncidents();

    // Limita e filtra solo incidenti importanti
    const criticalIncidents = incidents
      .filter(inc => inc.incidentDetails?.criticality >= 2)
      .slice(0, this.MAX_INCIDENT_MARKERS);

    for (let inc of criticalIncidents) {
      if (!inc.location?.shape?.links?.[0]?.points?.[0]) continue;

      const point = inc.location.shape.links[0].points[0];
      const lat = point.lat;
      const lng = point.lng;

      const criticality = inc.incidentDetails?.criticality || 1;
      const iconColor = criticality >= 3 ? '#ff0000' : '#ff8800';

      const icon = L.divIcon({
        html: `<div style="background-color: ${iconColor}; width: 16px; height: 16px; border-radius: 50%; border: 2px solid white; box-shadow: 0 2px 4px rgba(0,0,0,0.3);"></div>`,
        className: 'incident-marker',
        iconSize: [16, 16],
        iconAnchor: [8, 8]
      });

      const marker = L.marker([lat, lng], { icon: icon });

      const description = inc.incidentDetails?.description?.value || 'Incidente';
      marker.bindPopup(`<div style="padding: 8px;"><strong>🚨 ${description}</strong></div>`);

      marker.addTo(this.map!);
      this.incidentMarkers.push(marker);
    }

    console.log(`Incidenti disegnati: ${criticalIncidents.length} elementi`);
  }

  /**
   * Gestisce i cambi di zoom per ottimizzare le performance
   */
  private handleTrafficZoomChange(): void {
    const zoom = this.map?.getZoom() ?? 0;

    if (zoom < 11) {
      // Pulisci tutto a zoom bassi per migliorare le performance
      this.clearTrafficFlow();
      this.clearIncidents();
      console.log('Zoom basso: dati traffico nascosti per performance');
    } else if (this.activateRepo) {
      // Ricarica solo se necessario
      const now = Date.now();
      if (now - this.lastTrafficUpdate > 10000) { // 10 secondi di cooldown
        this.loadTrafficDataOptimized();
        this.lastTrafficUpdate = now;
      }
    }
  }

  /**
   * Calcola la distanza minima in base al zoom
   */
  private getMinDistanceByZoom(zoom: number): number {
    if (zoom >= 15) return 0.5; // km
    if (zoom >= 13) return 1;   // km
    if (zoom >= 11) return 2;   // km
    return 5; // km
  }

  /**
   * Aggiorna i campi agricoli sulla mappa in modo persistente (simile a updateMarkers)
   * @param fields Array dei campi agricoli
   * @param isFirstLoad Se è il primo caricamento (per eventuale centratura)
   */
  updateFields(fields: any[], isFirstLoad: boolean = false): void {
    if (!this.map || !this.fieldsLayerGroup) {
      console.warn('Mappa o layer group dei campi non inizializzato');
      return;
    }

    // console.log('🌾 updateFields chiamato con', fields.length, 'campi');

    // Gestisci il caso dell'array vuoto
    if (!fields || fields.length === 0) {
      // console.log('Array campi vuoto, rimuovo tutti i campi dalla mappa');

      // Rimuovi tutti i campi esistenti
      Object.keys(this.fieldsMap).forEach((fieldId) => {
        const polygon = this.fieldsMap[fieldId];
        this.fieldsLayerGroup!.removeLayer(polygon);
      });

      // Svuota la mappa dei campi
      this.fieldsMap = {};

      // console.log('Dopo la rimozione, campi rimanenti:', Object.keys(this.fieldsMap).length);
      return;
    }

    const currentFieldIds = fields.map((field) => field.uid || field.id || field.name);

    // Rimuovi i campi che non sono più presenti
    Object.keys(this.fieldsMap).forEach((fieldId) => {
      if (!currentFieldIds.includes(fieldId)) {
        const polygon = this.fieldsMap[fieldId];
        this.fieldsLayerGroup!.removeLayer(polygon);
        delete this.fieldsMap[fieldId];
        // console.log('🗑️ Campo rimosso:', fieldId);
      }
    });

    // Aggiungi o aggiorna i campi
    fields.forEach((field) => {
      const fieldId = field.uid || field.id || field.name;

      // Se il campo non esiste già, crealo
      if (!this.fieldsMap[fieldId]) {
        const polygon = this.createFieldPolygon(field);
        if (polygon) {
          this.fieldsMap[fieldId] = polygon;
          this.fieldsLayerGroup!.addLayer(polygon);
          // console.log('➕ Campo aggiunto:', fieldId);
        }
      }
      // Se il campo esiste già, non fare nulla (è già persistente sulla mappa)
    });

    // console.log('✅ updateFields completato. Campi sulla mappa:', Object.keys(this.fieldsMap).length);
  }

  /**
   * Crea un poligono per un campo agricolo (metodo helper per updateFields)
   */
  private createFieldPolygon(field: any): L.Polygon | null {
    if (!this.map) {
      return null;
    }

    let coordinates: any[] = [];

    // Estrai le coordinate dal field
    if (field.fieldGeometry) {
      coordinates = [...field.fieldGeometry.coordinates[0]];
    } else if (field.geometry) {
      let mode;
      if (field.drawConf) {
        if (typeof field.drawConf === 'string') {
          mode = JSON.parse(field.drawConf).mode;
        } else {
          mode = field.drawConf.mode;
        }
      }

      if (mode?.includes("Line")) {
        coordinates = [...field.geometry.coordinates];
      } else {
        coordinates = [...field.geometry.coordinates[0]];
      }
    }

    // Inverti le coordinate (da lng,lat a lat,lng per Leaflet)
    coordinates.forEach(coordinate => {
      coordinate.reverse();
    });

    // Determina il colore dal drawConf
    let color = 'blue';
    if (field.drawConf) {
      if (typeof field.drawConf === 'string') {
        color = JSON.parse(field.drawConf).color;
      } else {
        color = field.drawConf.color;
      }
    }

    // Crea il poligono
    const polygon: any = L.polygon(coordinates, { color: color });

    // Aggiungi tooltip se presente il nome
    if (field.name) {
      const tooltip = L.tooltip({
        direction: 'center',
        permanent: false,
        offset: [0, 20]
      }).setContent(field.name);

      polygon.bindTooltip(tooltip);

      // Gestisci la visibilità del tooltip in base alle impostazioni
      if (this.fieldLabelsVisible) {
        tooltip.options.permanent = true;
        polygon.openTooltip();
      }

      polygon.on('add', () => {
        tooltip.setLatLng(polygon.getBounds().getCenter());
      });

      this.map.on('moveend', () => {
        tooltip.setLatLng(polygon.getBounds().getCenter());
      });
    }

    return polygon;
  }

  /**
   * Disegna un poligono per un field agricolo sulla mappa
   * @param row Dati del field con geometry e drawConf
   * @param editable Se il poligono deve essere modificabile
   * @param navigate Se centrare la mappa sul poligono
   * @param addTooltip Se aggiungere il tooltip con il nome
   * @returns Il poligono L.Polygon creato
   */
  drawPolygonFields(row: any, editable = false, navigate = true, addTooltip = true): L.Polygon | null {
    if (!this.map) {
      console.warn('Mappa non inizializzata');
      return null;
    }

    let coordinates: any[] = [];

    // Estrai le coordinate dal field
    if (row.fieldGeometry) {
      coordinates = [...row.fieldGeometry.coordinates[0]];
    } else if (row.geometry) {
      let mode;
      if (row.drawConf) {
        if (typeof row.drawConf === 'string') {
          mode = JSON.parse(row.drawConf).mode;
        } else {
          mode = row.drawConf.mode;
        }
      }

      if (mode?.includes("Line")) {
        coordinates = [...row.geometry.coordinates];
      } else {
        coordinates = [...row.geometry.coordinates[0]];
      }
    }

    // Inverti le coordinate (da lng,lat a lat,lng per Leaflet)
    coordinates.forEach(coordinate => {
      coordinate.reverse();
    });

    // Determina il colore dal drawConf
    let color = 'blue';
    if (row.drawConf) {
      if (typeof row.drawConf === 'string') {
        color = JSON.parse(row.drawConf).color;
      } else {
        color = row.drawConf.color;
      }
    }

    // Crea il poligono
    const polygon: any = L.polygon(coordinates, { color: color });

    // Aggiungi tooltip se richiesto, ma non mostrarlo di default
    if (addTooltip && row.name) {
      const tooltip = L.tooltip({
        direction: 'center',
        permanent: false, // Cambiato a false per evitare visualizzazione automatica
        offset: [0, 20]
      }).setContent(row.name);

      polygon.bindTooltip(tooltip);

      // Non aprire il tooltip di default - sarà gestito dal bottone fieldLabels
      // Il tooltip verrà mostrato solo se fieldLabelsVisible è true
      if (this.fieldLabelsVisible) {
        // Se i labels devono essere visibili, rendi il tooltip permanente e aprilo
        tooltip.options.permanent = true;
        polygon.openTooltip();
      }

      polygon.on('add', () => {
        tooltip.setLatLng(polygon.getBounds().getCenter());
      });

      this.map.on('moveend', () => {
        tooltip.setLatLng(polygon.getBounds().getCenter());
      });
    }    // Aggiungi il poligono alla lista e al gruppo
    this.polygonsFields.push(polygon);
    this.polygonGroupLayer = L.featureGroup(this.polygonsFields);

    // Abilita editing se richiesto (commentiamo per ora finché non importiamo leaflet.pm)
    // if (editable && polygon.editing) {
    //   polygon.editing.enable();
    //   polygon.on('edit', (e: any) => {
    //     console.log('Field polygon edited:', e.target);
    //   });
    // }

    // Aggiungi alla mappa
    this.map.addLayer(this.polygonGroupLayer);

    // Naviga al poligono se richiesto
    if (navigate) {
      this.map.fitBounds(polygon.getBounds(), {
        padding: [20, 20],
        maxZoom: 16
      });
    }

    return polygon;
  }

  /**
   * Rimuove tutti i poligoni dei fields dalla mappa
   */
  removeAllPolygonsFields(): void {
    if (!this.map) {
      console.warn('Mappa non inizializzata');
      return;
    }

    // Usa il nuovo sistema persistente
    if (this.fieldsLayerGroup) {
      Object.keys(this.fieldsMap).forEach((fieldId) => {
        const polygon = this.fieldsMap[fieldId];
        this.fieldsLayerGroup!.removeLayer(polygon);
      });
      this.fieldsMap = {};
      // console.log('🗑️ Tutti i campi rimossi dal nuovo sistema persistente');
    }

    // Mantieni compatibilità con il vecchio sistema
    if (this.polygonsFields?.length > 0) {
      this.polygonsFields.forEach(polygon => {
        this.map!.removeLayer(polygon);
      });
      this.polygonsFields = [];
    }

    if (this.polygonGroupLayer) {
      this.map.removeLayer(this.polygonGroupLayer);
      this.polygonGroupLayer = undefined;
    }
  }

  /**
   * Ottiene il numero di poligoni dei fields attualmente sulla mappa
   */
  getFieldsPolygonsCount(): number {
    // Usa il nuovo sistema persistente se disponibile
    if (this.fieldsMap) {
      return Object.keys(this.fieldsMap).length;
    }
    // Fallback al vecchio sistema
    return this.polygonsFields.length;
  }

  /**
   * Nasconde tutti i poligoni dei fields senza rimuoverli
   */
  hideFieldsPolygons(): void {
    // Usa il nuovo sistema persistente
    if (this.fieldsLayerGroup && this.map) {
      this.map.removeLayer(this.fieldsLayerGroup);
    }

    // Mantieni compatibilità con il vecchio sistema
    if (this.polygonGroupLayer && this.map) {
      this.map.removeLayer(this.polygonGroupLayer);
    }
  }

  /**
   * Mostra tutti i poligoni dei fields nascosti
   */
  showFieldsPolygons(): void {
    // Usa il nuovo sistema persistente
    if (this.fieldsLayerGroup && this.map) {
      this.map.addLayer(this.fieldsLayerGroup);
    }

    // Mantieni compatibilità con il vecchio sistema
    if (this.polygonGroupLayer && this.map) {
      this.map.addLayer(this.polygonGroupLayer);
    }
  }

  /**
   * Mostra le etichette dei field agricoli
   */
  showFieldLabels(): void {
    if (!this.map) {
      console.error('La mappa non è stata inizializzata.');
      return;
    }

    // console.log('Mostrando etichette dei field...');

    this.fieldLabelsVisible = true;

    // Gestisci il vecchio sistema (per compatibilità)
    this.polygonsFields.forEach((polygon: any) => {
      if (polygon && polygon.getTooltip && polygon.getTooltip()) {
        const tooltip = polygon.getTooltip();
        if (tooltip) {
          // Rendi il tooltip permanente e aprilo
          tooltip.options.permanent = true;
          if (!polygon.isTooltipOpen()) {
            polygon.openTooltip();
          }
        }
      }
    });

    // Gestisci il nuovo sistema persistente
    this.updateFieldLabelsVisibility();

    // console.log('Etichette field mostrate');
  }

  /**
   * Nasconde le etichette dei field agricoli
   */
  hideFieldLabels(): void {
    if (!this.map) {
      console.error('La mappa non è stata inizializzata.');
      return;
    }

    // console.log('Nascondendo etichette dei field...');

    this.fieldLabelsVisible = false;

    // Gestisci il vecchio sistema (per compatibilità)
    this.polygonsFields.forEach((polygon: any) => {
      if (polygon && polygon.getTooltip) {
        const tooltip = polygon.getTooltip();
        if (tooltip) {
          // Chiudi il tooltip e rendilo non permanente
          polygon.closeTooltip();
          tooltip.options.permanent = false;
        }
      }
    });

    // Gestisci il nuovo sistema persistente
    this.updateFieldLabelsVisibility();

    // console.log('Etichette field nascoste');
  }

  /**
   * Toggle della visibilità delle etichette dei campi agricoli
   */
  toggleFieldLabels(): boolean {
    if (this.fieldLabelsVisible) {
      this.hideFieldLabels();
    } else {
      this.showFieldLabels();
    }
    return this.fieldLabelsVisible;
  }

  /**
   * Aggiorna la visibilità delle etichette per i campi nel nuovo sistema persistente
   */
  updateFieldLabelsVisibility(): void {
    if (!this.fieldsMap) {
      return;
    }

    Object.values(this.fieldsMap).forEach((polygon: any) => {
      if (polygon && polygon.getTooltip) {
        const tooltip = polygon.getTooltip();
        if (tooltip) {
          if (this.fieldLabelsVisible) {
            // Mostra l'etichetta
            tooltip.options.permanent = true;
            polygon.openTooltip();
          } else {
            // Nascondi l'etichetta
            polygon.closeTooltip();
            tooltip.options.permanent = false;
          }
        }
      }
    });
  }

  /**
   * Mostra tutti i fields agricoli sulla mappa
   */
  showAllFields(): void {
    if (!this.map || !this.fieldsLayerGroup) {
      console.error('La mappa o il fieldsLayerGroup non sono inizializzati.');
      return;
    }

    console.log('Mostrando tutti i fields agricoli...');

    // Aggiungi il layer group alla mappa se non è già presente
    if (!this.map.hasLayer(this.fieldsLayerGroup)) {
      this.map.addLayer(this.fieldsLayerGroup);
    }

    this.fieldLabelsVisible = true;
    console.log('Tutti i fields agricoli mostrati');
  }

  /**
   * Nasconde tutti i fields agricoli dalla mappa
   */
  hideAllFields(): void {
    if (!this.map || !this.fieldsLayerGroup) {
      console.error('La mappa o il fieldsLayerGroup non sono inizializzati.');
      return;
    }

    console.log('Nascondendo tutti i fields agricoli...');

    // Rimuovi il layer group dalla mappa
    if (this.map.hasLayer(this.fieldsLayerGroup)) {
      this.map.removeLayer(this.fieldsLayerGroup);
    }

    this.fieldLabelsVisible = false;
    console.log('Tutti i fields agricoli nascosti');
  }

  /**
   * Toggle della visibilità di tutti i fields agricoli
   */
  toggleAllFields(): boolean {
    if (this.fieldLabelsVisible) {
      this.hideAllFields();
    } else {
      this.showAllFields();
    }
    return this.fieldLabelsVisible;
  }

  /**
   * Aggiunge il controllo meteo alla mappa
   */
  addWeatherControl(): void {
    // console.log('Inizio addWeatherControl()');

    if (!this.map) {
      console.error('Mappa non disponibile in addWeatherControl');
      return;
    }

    const weatherBaseUrl = this.weatherApiBaseUrl;
    const weatherApiUrl = 'http://' + weatherBaseUrl + '/maps/2.0/weather/{op}/{z}/{x}/{y}?date={date}&palette={palette}&appid=' + this.weatherApiKey;
    const weatherTsUrl = 'http://' + weatherBaseUrl + '/maps/2.0/weather/{op}/{z}/{x}/{y}?palette={palette}&appid=' + this.weatherApiKey;
    const weatherOpacityUrl = 'http://' + weatherBaseUrl + '/maps/2.0/weather/{op}/{z}/{x}/{y}?date={date}&opacity={opacity}&palette={palette}&appid=' + this.weatherApiKey;

    // console.log('URLs configurate:', { weatherApiUrl, weatherTsUrl, weatherOpacityUrl });

    try {
      (L.Control as any).WeatherControl = this.initWeatherToolBar();
      //console.log('WeatherControl definito');

      (L.control as any).weatherControl = function (wopt: any) {
        return new (L.Control as any).WeatherControl(wopt);
      };
      //console.log('weatherControl function definita');

      const weatherControl = (L.control as any).weatherControl({
        position: 'topleft',
        weatherOptions: this.weatherLayerOpts,
        weatherUrl: weatherApiUrl,
        weatherTsUrl: weatherTsUrl,
        weatherOpacityUrl: weatherOpacityUrl
      });

     // console.log('WeatherControl creato, aggiungendo alla mappa...');
      weatherControl.addTo(this.map);
     // console.log('WeatherControl aggiunto alla mappa con successo');

      // Verifica che la toolbar sia stata creata e inizializza l'event listener del bottone
      setTimeout(() => {
        const toolbar = document.getElementsByClassName("weather-toolbar-div")[0];
        if (toolbar) {
         // console.log('Toolbar meteo trovata nel DOM:', toolbar);
         // console.log('Classi toolbar:', toolbar.className);

          // Ora aggiungi l'event listener al bottone weather
          this.initializeWeatherButtonListener();
        } else {
          console.error('Toolbar meteo NON trovata nel DOM dopo l\'aggiunta');
        }
      }, 100);

    } catch (error) {
      console.error('Errore in addWeatherControl:', error);
    }
  }

  /**
   * Inizializza l'event listener per il bottone weather
   */
  private initializeWeatherButtonListener(): void {
    const weatherButtons = document.querySelectorAll('.weather');
    const mainColor = this.utilsService.getMainColor();

    weatherButtons.forEach((weatherButton: any) => {
      let isWeatherActive = false;

      weatherButton.addEventListener('click', () => {
        // console.log('Click sul bottone weather, stato attuale:', isWeatherActive);

        // Trova la toolbar meteo
        let toolbar = document.getElementsByClassName("weather-toolbar-div")[0] as HTMLElement;
        if (!toolbar) {
          console.error('Toolbar meteo non trovata nel DOM');
          return;
        }

        isWeatherActive = !isWeatherActive;
        // console.log('Nuovo stato weather:', isWeatherActive);

        if (isWeatherActive) {
          // Attiva il meteo e mostra la toolbar
          weatherButton.classList.remove('bg-white');
          weatherButton.style.backgroundColor = mainColor;
          toolbar.classList.remove('hidden');
          this.weatherActive = true;
          // console.log('Meteo attivato - toolbar mostrata');
        } else {
          // Disattiva il meteo e nascondi la toolbar
          weatherButton.classList.add('bg-white');
          weatherButton.style.backgroundColor = '#ffffff';
          toolbar.classList.add('hidden');

          // Rimuovi tutti i layer meteo attivi
          this.clearActiveWeatherLayers();
          this.weatherActive = false;
          // console.log('Meteo disattivato - toolbar nascosta');
        }
      });
    });
  }

  /**
   * Inizializza la toolbar meteo
   */
  initWeatherToolBar(): any {
    const self = this;
    return L.Control.extend({
      options: {},
      initialize: function (options: any) {
        L.setOptions(this, options);
        self.weatherLayerEndpoint = options['weatherUrl'];
        self.weatherTsUrlEndpoint = options['weatherTsUrl'];
        self.weatherOpacityUrl = options['weatherOpacityUrl'];
      },
      onAdd: function (map: any) {
        const _container = L.DomUtil.create('div', 'weather-toolbar-div hidden');
        const weatherKeys = Object.keys(self.weatherLayerOpts);

        for (let weatherIndex = 0; weatherIndex < weatherKeys.length; weatherIndex++) {
          const weatherItemWrap = L.DomUtil.create('div', 'weather-toolbar-item-wrap');
          const weatherItemButton = L.DomUtil.create('div', 'weather-toolbar-item');
          const weatherItemContent = L.DomUtil.create('span', 'weather-toolbar-item-span');

          weatherItemContent.textContent = self.weatherLayerOpts[weatherKeys[weatherIndex]].layerName;
          weatherItemWrap.appendChild(weatherItemButton);
          weatherItemWrap.appendChild(weatherItemContent);
          _container.appendChild(weatherItemWrap);

          weatherItemContent.setAttribute('weather-data-layerid', (weatherIndex + 1).toString());
          weatherItemContent.setAttribute('data-selected', 'false');
          weatherItemButton.setAttribute('weather-data-layerid', (weatherIndex + 1).toString());
          weatherItemButton.setAttribute('data-selected', 'false');

          L.DomUtil.create('i', self.weatherLayerOpts[weatherKeys[weatherIndex]].iconName, weatherItemButton);
          L.DomEvent.addListener(weatherItemButton, 'click', this._onLayerClick.bind(this), this);
          L.DomEvent.addListener(weatherItemButton, 'dblclick', this._disableZoom.bind(this), this);
          L.DomEvent.addListener(weatherItemContent, 'click', this._onLayerClick.bind(this), this);
          L.DomEvent.addListener(weatherItemContent, 'dblclick', this._disableZoom.bind(this), this);
        }

        return _container;
      },
      _toggleLayers: function (layerId: number, selected: boolean, e: any) {
        const toolbar = (<HTMLCollectionOf<HTMLElement>>document.getElementsByClassName("weather-toolbar-div"))[0];

        for (let i = 0; i < toolbar.children.length; i++) {
          toolbar.children[i].children[0]?.classList.remove('aft-leaflet-toolbar-item__active');
          toolbar.children[i].children[1]?.classList.remove('aft-leaflet-toolbar-item__active');
          toolbar.children[i].setAttribute('data-selected', 'false');
        }
        self.selectedWeatherLayers = [];

        if (!selected) {
          self.selectedWeatherLayers[0] = layerId;
          const domElemsByLayerId = document.querySelectorAll('[weather-data-layerid="' + layerId + '"]');
          domElemsByLayerId.forEach(function (domElem: any) {
            domElem?.classList.add('aft-leaflet-toolbar-item__active');
            domElem.setAttribute('data-selected', (!selected).toString());
          });
        }
      },
      _onLayerClick: function (e: any) {
        e.stopPropagation();
        const layerId = parseInt(e.currentTarget.getAttribute('weather-data-layerid'));
        let selected: boolean;

        if (self.globalLayerId !== layerId) {
          selected = false;
          self.globalLayerId = layerId;
        } else {
          selected = true;
          self.globalLayerId = 0;
        }

        this._toggleLayers(layerId, selected, e);

        const forecastValue = self.utilsService.getNowTimezoneJS();
        self.updateWeatherLayer(forecastValue, true);
        e.currentTarget.setAttribute('data-selected', !selected);
      },
      _disableZoom: function (e: any) {
        self.map!.doubleClickZoom.disable();
        setTimeout(() => {
          self.map!.doubleClickZoom.enable();
        }, 300);
      }
    });
  }

  /**
   * Aggiorna il layer meteo sulla mappa
   */
  updateWeatherLayer(date: any, hasLayerChanged: boolean): void {
    date = new Date(date);
    const self = this;

    this.map!.eachLayer(function (layer: any) {
      if (layer._url === self.weatherLayerEndpoint ||
          layer._url === self.weatherTsUrlEndpoint ||
          layer._url === self.weatherOpacityUrl) {
        self.map!.removeLayer(layer);
      }
    });

    const weatherOpts: any = {};
    let layerToShow: any;

    Object.assign(weatherOpts, { "date": self.utilsService.mathround(self.utilsService.toUTC(date) / 1000, 0) });

    switch (self.selectedWeatherLayers[0]) {
      case 1:
        Object.assign(weatherOpts, self.weatherLayerOpts.accumulated_precipitation);
        layerToShow = L.tileLayer(self.weatherLayerEndpoint, weatherOpts);
        self.map!.addLayer(layerToShow);
        break;
      case 2:
        Object.assign(weatherOpts, self.weatherLayerOpts.accumulated_precipitation_snow);
        layerToShow = L.tileLayer(self.weatherLayerEndpoint, weatherOpts);
        self.map!.addLayer(layerToShow);
        break;
      case 3:
        Object.assign(weatherOpts, self.weatherLayerOpts.wind_speed);
        layerToShow = L.tileLayer(self.weatherLayerEndpoint, weatherOpts);
        self.map!.addLayer(layerToShow);
        break;
      case 4:
        Object.assign(weatherOpts, self.weatherLayerOpts.winds);
        layerToShow = L.tileLayer(self.weatherLayerEndpoint, weatherOpts);
        self.map!.addLayer(layerToShow);
        break;
      case 5:
        Object.assign(weatherOpts, self.weatherLayerOpts.air_temperature);
        layerToShow = L.tileLayer(self.weatherLayerEndpoint, weatherOpts);
        self.map!.addLayer(layerToShow);
        break;
      case 6:
        Object.assign(weatherOpts, self.weatherLayerOpts.dew_point);
        layerToShow = L.tileLayer(self.weatherLayerEndpoint, weatherOpts);
        self.map!.addLayer(layerToShow);
        break;
      case 7:
        Object.assign(weatherOpts, self.weatherLayerOpts.relative_humidity);
        layerToShow = L.tileLayer(self.weatherOpacityUrl, weatherOpts);
        self.map!.addLayer(layerToShow);
        break;
      case 8:
        Object.assign(weatherOpts, self.weatherLayerOpts.cloudiness);
        layerToShow = L.tileLayer(self.weatherLayerEndpoint, weatherOpts);
        self.map!.addLayer(layerToShow);
        break;
    }

    if (hasLayerChanged) {
      this.updateChoroplethIndex(weatherOpts);
    }
  }

  /**
   * Aggiorna l'indice cromatico per i layer meteo
   */
  updateChoroplethIndex(choroOptions: any): void {
    const self = this;

    if (this.selectedWeatherLayers.length > 0) {
      this.scaleWrapper?.classList.remove("hidden");
      if (this.choroplethScale) {
        this.choroplethScale.innerHTML = "";
      }

      const limit = 98.5 / (choroOptions.paletteArray.length - 1);
      let labelCount = 0;
      let gradientStyleString = "linear-gradient(to right";

      choroOptions.paletteArray.forEach(function (iter: any, i: number) {
        const addedRow = L.DomUtil.create('div');
        addedRow?.classList.add('scale-value');
        const labelSpan = L.DomUtil.create('span');
        labelSpan.textContent = "" + Object.keys(iter)[0];
        addedRow.appendChild(labelSpan);

        if (i === 0) {
          addedRow.setAttribute("style", "right: 98,5%");
        } else if (i == choroOptions.paletteArray.length - 1) {
          addedRow.setAttribute("style", "right: 0%");
        } else {
          addedRow.setAttribute("style", "right: " + (98.5 - labelCount) + "%");
        }

        labelCount += limit;
        gradientStyleString += ", #" + Object.values(iter)[0] + " " + labelCount + "%";

        if (self.choroplethScale) {
          self.choroplethScale.appendChild(addedRow);
        }
      });

      gradientStyleString += ");";

      if (this.choroplethScale) {
        this.choroplethScale.setAttribute("style", "background-image: " + gradientStyleString);
      }

      if (this.currentLayerName) {
        this.currentLayerName.textContent = choroOptions.layerName + " (" + choroOptions.unitOfMeasure + ")";
      }
    } else {
      this.scaleWrapper?.classList.add("hidden");
    }
  }

  /**
   * Controlla se la configurazione è cambiata confrontando le proprietà dei campi
   */
  private hasConfigChanged(prevConfig: any, newConfig: any): boolean {
    console.log('� FORZANDO RETURN TRUE PER TEST - hasConfigChanged');

    console.log('�🔍 HAS CONFIG CHANGED - Controllo cambiamenti configurazione:', {
      hasPrevFields: !!prevConfig?.fields,
      hasNewFields: !!newConfig?.fields,
      prevFieldsCount: prevConfig?.fields ? Object.keys(prevConfig.fields).length : 0,
      newFieldsCount: newConfig?.fields ? Object.keys(newConfig.fields).length : 0
    });

    if (!prevConfig?.fields || !newConfig?.fields) {
      console.log('🔍 HAS CONFIG CHANGED - Mancano campi, ritorno false');
      return false;
    }

    const prevFields = prevConfig.fields;
    const newFields = newConfig.fields;

    // Controlla tutti i campi presenti in entrambe le configurazioni
    const allFields = new Set([
      ...Object.keys(prevFields),
      ...Object.keys(newFields)
    ]);

    let changesDetected = 0;
    console.log(`🔍 HAS CONFIG CHANGED - Controllo ${allFields.size} campi...`);

    for (const fieldName of allFields) {
      const prevField = prevFields[fieldName] || {};
      const newField = newFields[fieldName] || {};

      // Log dettagliato per ogni campo (solo per ad e actr per evitare spam)
      if (fieldName === 'ad' || fieldName === 'actr') {
        console.log(`🔍 DETTAGLIO CAMPO ${fieldName}:`, {
          prevField: {
            showInPopup: prevField.showInPopup,
            showInSidebar: prevField.showInSidebar,
            showInDetails: prevField.showInDetails,
            visible: prevField.visible
          },
          newField: {
            showInPopup: newField.showInPopup,
            showInSidebar: newField.showInSidebar,
            showInDetails: newField.showInDetails,
            visible: newField.visible
          }
        });
      }

      // Normalizza i valori undefined come false per un confronto più accurato
      const prevVisible = prevField.visible ?? false;
      const newVisible = newField.visible ?? false;
      const prevShowInPopup = prevField.showInPopup ?? false;
      const newShowInPopup = newField.showInPopup ?? false;
      const prevShowInSidebar = prevField.showInSidebar ?? false;
      const newShowInSidebar = newField.showInSidebar ?? false;
      const prevShowInDetails = prevField.showInDetails ?? false;
      const newShowInDetails = newField.showInDetails ?? false;

      // Controlla se qualche proprietà rilevante per i popup è cambiata
      const visibleChanged = prevVisible !== newVisible;
      const showInPopupChanged = prevShowInPopup !== newShowInPopup;
      const showInSidebarChanged = prevShowInSidebar !== newShowInSidebar;
      const showInDetailsChanged = prevShowInDetails !== newShowInDetails;

      // Log dettagliato del confronto (solo per ad e actr)
      if (fieldName === 'ad' || fieldName === 'actr') {
        console.log(`🔍 CONFRONTO ${fieldName}:`, {
          visibleChanged: `${prevVisible} → ${newVisible} = ${visibleChanged}`,
          showInPopupChanged: `${prevShowInPopup} → ${newShowInPopup} = ${showInPopupChanged}`,
          showInSidebarChanged: `${prevShowInSidebar} → ${newShowInSidebar} = ${showInSidebarChanged}`,
          showInDetailsChanged: `${prevShowInDetails} → ${newShowInDetails} = ${showInDetailsChanged}`
        });
      }

      if (visibleChanged || showInPopupChanged || showInSidebarChanged || showInDetailsChanged) {
        changesDetected++;
        console.log(`🔄 CAMPO CAMBIATO - ${fieldName}:`, {
          visible: `${prevVisible} → ${newVisible}`,
          showInPopup: `${prevShowInPopup} → ${newShowInPopup}`,
          showInSidebar: `${prevShowInSidebar} → ${newShowInSidebar}`,
          showInDetails: `${prevShowInDetails} → ${newShowInDetails}`
        });
        return true;
      }
    }

    console.log(`🔍 HAS CONFIG CHANGED - Controllo completato: ${changesDetected} cambiamenti rilevati`);

    return false;
  }

  /**
   * Aggiorna i popup di tutti i marker esistenti con la nuova configurazione
   */
  private updateAllMarkersPopups(): void {
    // console.log('🎯🎯🎯 POPUP UPDATE - updateAllMarkersPopups chiamato!');
    // console.log('🔄 UPDATE ALL POPUPS - Inizio aggiornamento popup');

    if (!this.markersMap || Object.keys(this.markersMap).length === 0) {
      console.log('🔄 UPDATE ALL POPUPS - Nessun marker da aggiornare');
      return;
    }

    console.log('🔄 UPDATE ALL POPUPS - Aggiornamento popup per', Object.keys(this.markersMap).length, 'marker');

    // Ottengo le etichette tradotte
    // const lblDriver = this.translateService.instant('mapPage.driver');
    // const lblInternalID = this.translateService.instant('mapPage.internalId');
    // const lblStartTime = this.translateService.instant('mapPage.startTime');
    // const lblCurrentPosition = this.translateService.instant('mapPage.currentPosition');
    // const lblDirection = this.translateService.instant('mapPage.direction');
    // const lblState = this.translateService.instant('mapPage.state');
    // const lblSince = this.translateService.instant('mapPage.since');
    // const lblLastUpdate = this.translateService.instant('mapPage.lastUpdate');
    // const lblTodayDistance = this.translateService.instant('mapPage.todayDistance');
    // const lblTodayConsumption = this.translateService.instant('mapPage.todayConsumption');
    // const lblFuelLevel1 = this.translateService.instant('mapPage.fuelLevel1');
    // const lblFuelLevel2 = this.translateService.instant('mapPage.fuelLevel2');

    // Helper method per costruire il popup content basato sulla configurazione
    const buildPopupContent = (vehicle: any, popupColorClass: string) => {
      let popupContent = `<div class="popup-content ${popupColorClass}" style="display: flex; flex-direction: column; gap: 8px;">`;

      // VIN sempre visibile
      const vin = vehicle.vin || '-';
      popupContent += `
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="font-style: italic;" class="text-xs">VIN:</div>
          <div style="font-weight: bold; text-align: right;" class="text-xs">${vin}</div>
        </div>`;

      // 🔧 LEGGI SEMPRE DALLO STORE NGRX per avere i dati aggiornati in tempo reale
      let currentConfig: any = null;
      this.store.select(selectMappingConfig)
        .pipe(take(1))
        .subscribe(config => {
          currentConfig = config;
        });

      if (currentConfig && currentConfig.fields) {
        // Filtra i campi che devono essere mostrati nel popup
        const filteredKeys = Object.keys(currentConfig.fields)
          .filter(storageKey => {
            const fieldConfig = currentConfig.fields[storageKey];
            const fieldName = extractNameFromFieldConfigKey(storageKey);
            const isBasicVisible = fieldConfig.visible !== false &&
              fieldConfig.showInPopup === true &&
              this.isCatalogVisible(fieldName);

            if (!isBasicVisible) return false;

            if (vehicle.can_map_name) {
              return this.vehicleService.isFieldVisibleForVehicle(fieldName, vehicle.can_map_name);
            }

            return true;
          });

        // Ordina per scope (come sidebar/dettagli) e, a parità di scope, per displayOrder
        const popupFields = this.sortPopupFields(filteredKeys, currentConfig.fields);

        // console.log('🎯 POPUP UPDATEALL - Campi abilitati per popup (da STORE):', popupFields.length);
        // console.log('🎯 POPUP UPDATEALL - Campi selezionati:', popupFields);
        // console.log('🎯 POPUP UPDATEALL - Sto per generare popup content...');
        // console.log('🎯 POPUP UPDATEALL - Campi selezionati:', popupFields);

        // Crea le righe per ogni campo abilitato
        popupFields.forEach(storageKey => {
          const fieldConfig = currentConfig.fields[storageKey];
          const fieldName = extractNameFromFieldConfigKey(storageKey);
          const label = this.generateFieldLabel(fieldName, fieldConfig);
          const value = this.formatPopupFieldValue(fieldName, fieldConfig, vehicle[fieldName]);

          popupContent += `
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <div style="font-style: italic;" class="text-xs">${label}:</div>
              <div style="font-weight: bold; text-align: right;" class="text-xs">${value}</div>
            </div>`;
        });

        // Altri campi configurabili aggiunti sopra (VIN già sempre presente)
      } else {
        // Fallback se non c'è configurazione - VIN già aggiunto sopra
      }

      popupContent += '</div>';
      return popupContent;
    };

    // Aggiorna tutti i marker esistenti
    Object.keys(this.markersMap).forEach(vin => {
      const marker = this.markersMap[vin];
      const vehicleData = (marker as any).vehicleData;

      if (vehicleData) {
        const vehicle_status = vehicleData.vehicle_status || 'UNKNOWN';
        const popupColorClass = {
          PARKED: 'popup-gray',
          MOVING: 'popup-green',
          IDLE: 'popup-orange',
          UNKNOWN: 'popup-white',
          NOTCONNECTED: 'popup-white'
        }[vehicle_status] || 'popup-default';

        const newPopupContent = buildPopupContent(vehicleData, popupColorClass);

        // Aggiorna il contenuto del popup
        const currentPopup = marker.getPopup();
        if (currentPopup) {
          currentPopup.setContent(newPopupContent);

          // Se il popup è attualmente aperto, forza l'aggiornamento
          if (marker.isPopupOpen && marker.isPopupOpen()) {
            marker.closePopup();
            marker.openPopup();
          }
        } else {
          // Se non c'è popup, creane uno nuovo
          marker.bindPopup(newPopupContent);
        }
      }
    });

    console.log('✅ Popup aggiornati con successo');
  }

  /**
   * Centra la mappa su tutti gli elementi presenti (veicoli e campi)
   */
  centerMapOnAllElements(): void {
    if (!this.map) {
      console.warn('Mappa non inizializzata');
      return;
    }

    const bounds = L.latLngBounds([]);
    let hasElements = false;

    // Aggiungi i marker dei veicoli ai bounds
    if (this.markerClusterGroup) {
      this.markerClusterGroup.eachLayer((layer: any) => {
        if (layer instanceof L.Marker) {
          bounds.extend(layer.getLatLng());
          hasElements = true;
        }
      });
    }

    // Aggiungi i poligoni dei campi ai bounds (sistema persistente usato da updateFields)
    if (this.fieldsLayerGroup) {
      this.fieldsLayerGroup.eachLayer((layer: any) => {
        if (layer instanceof L.Polygon) {
          bounds.extend(layer.getBounds());
          hasElements = true;
        }
      });
    }

    // Aggiungi anche i poligoni disegnati manualmente (drawPolygonFields), se presenti
    if (this.polygonGroupLayer) {
      this.polygonGroupLayer.eachLayer((layer: any) => {
        if (layer instanceof L.Polygon) {
          bounds.extend(layer.getBounds());
          hasElements = true;
        }
      });
    }

    // Centra la mappa se ci sono elementi
    if (hasElements && bounds.isValid()) {
   //   console.log('🎯 Centrando mappa su tutti gli elementi');
      this.map.fitBounds(bounds, {
        padding: [20, 20],
        maxZoom: 16
      });
    } else {
      console.log('⚠️ Nessun elemento trovato per centrare la mappa');
    }
  }

  /**
   * Genera l'etichetta tradotta per un campo nel popup del marker
   * Prima cerca la traduzione usando la chiave dashboards.signals.{fieldName}
   * Se non trova la traduzione, usa l'etichetta originale dalla configurazione
   */
  private generateFieldLabel(fieldName: string, fieldConfig: any): string {
    const scoped = fieldConfig?.scope ? this.mergedFieldsMap[buildFieldConfigKey(fieldConfig.scope, fieldName)] : undefined;
    return scoped?.label || this.mergedFieldsMap[fieldName]?.label || fieldConfig?.label || fieldName;
  }

  /**
   * Formatta il valore di un campo per il popup del marker.
   * Nessun dato -> '-' (senza unità). Altrimenti applica le formattazioni
   * specifiche (data, distanza, carburante) oppure aggiunge l'unità di misura dalla config.
   */
  private formatPopupFieldValue(fieldName: string, fieldConfig: any, rawValue: any): string {
    if (rawValue === null || rawValue === undefined || rawValue === '') {
      return '-';
    }

    if (fieldName.includes('time') || fieldName.includes('date')) {
      return this.datePipe.transform(rawValue, 'dd/MM/yyyy HH:mm:ss') || '-';
    }

    if (fieldName.includes('distance') && typeof rawValue === 'number') {
      return this.utilsService.convertFromKm(rawValue / 1000) + ' ' + this.utilsService.getDistanceLabel();
    }

    if (fieldName.includes('fuel') && typeof rawValue === 'number') {
      if (fieldName.includes('level')) {
        return rawValue.toFixed(1) + '%';
      }
      if (fieldName.includes('consumption')) {
        return rawValue.toFixed(2) + ' L';
      }
    }

    const unit = fieldConfig?.unit;
    return unit ? `${rawValue} ${unit}` : `${rawValue}`;
  }

  /**
   * Ordina i campi del popup per scope (stesso ordine di sidebar/dettagli) e,
   * all'interno di ogni scope, per displayOrder (poi alfabetico per label).
   */
  private sortPopupFields(fieldNames: string[], fieldsConfig: any): string[] {
    const fieldsByScope: { [scope: string]: string[] } = {};
    fieldNames.forEach(fieldName => {
      const scope = fieldsConfig[fieldName]?.scope || 'other';
      if (!fieldsByScope[scope]) {
        fieldsByScope[scope] = [];
      }
      fieldsByScope[scope].push(fieldName);
    });

    const orderedScopes = this.getPopupScopeOrder(fieldsByScope);

    return orderedScopes.reduce((acc: string[], scope) => {
      const sortedScopeFields = fieldsByScope[scope].sort((a, b) => {
        const fieldConfigA = fieldsConfig[a];
        const fieldConfigB = fieldsConfig[b];
        const orderA = fieldConfigA?.displayOrder ?? 999999;
        const orderB = fieldConfigB?.displayOrder ?? 999999;

        if (orderA !== orderB) {
          return orderA - orderB;
        }

        const labelA = this.generateFieldLabel(a, fieldConfigA);
        const labelB = this.generateFieldLabel(b, fieldConfigB);
        return labelA.localeCompare(labelB);
      });
      return acc.concat(sortedScopeFields);
    }, []);
  }

  /**
   * Ottiene l'ordine degli scope dal localStorage (stesso salvato dal settings panel per sidebar/dettagli),
   * con fallback all'ordine di default. Gli scope non previsti dall'ordine di default vengono comunque inclusi in coda.
   */
  private getPopupScopeOrder(fieldsByScope: { [scope: string]: string[] }): string[] {
    const presentScopes = Object.keys(fieldsByScope);

    try {
      const saved = localStorage.getItem('settings-panel-scope-order');
      if (saved) {
        const savedOrder = JSON.parse(saved);
        const validScopes = savedOrder.filter((scope: string) => fieldsByScope[scope]?.length > 0);
        const newScopes = presentScopes.filter(scope => !validScopes.includes(scope));
        return [...validScopes, ...newScopes];
      }
    } catch (error) {
      this.logger.error('actia-map', 'Errore nel caricamento ordine scope popup:', error);
    }

    const defaultOrder = [...MAP_FIELD_SCOPES, 'common', 'model', 'other', 'general'];
    const validDefaultScopes = defaultOrder.filter(scope => fieldsByScope[scope]?.length > 0);
    const remainingScopes = presentScopes.filter(scope => !defaultOrder.includes(scope as any));
    return [...validDefaultScopes, ...remainingScopes];
  }

  private isCatalogVisible(fieldName: string): boolean {
    return this.catalogVisibleFieldNames.size === 0 || this.catalogVisibleFieldNames.has(fieldName);
  }

  // Geofence methods
  geofenceToggle(): void {
    // Logica semplice: apri/chiudi pannello e carica/nascondi geofence
    if (!this.geofencePanelVisible) {
      // Apri pannello e carica geofence
      this.geofencePanelVisible = true;
      this.geofenceActive = true;
      this.loadAndShowGeofences();
      this.changeGeofence.next(true);
      this.geofencePanelToggle.next(true);
      console.log('�️ Geofence: Pannello aperto e geofence caricati');
    } else {
      // Chiudi pannello e nascondi geofence
      this.geofencePanelVisible = false;
      this.geofenceActive = false;
      this.removeAllPolygonsGeofence();
      this.changeGeofence.next(false);
      this.geofencePanelToggle.next(false);
      console.log('❌ Geofence: Pannello chiuso e geofence nascosti');
    }

    // Aggiorna lo stato visuale del bottone
    this.updateGeofenceButtonState();
  }

  /**
   * Aggiorna lo stato visuale del bottone geofence
   */
  private updateGeofenceButtonState(): void {
    const mainColor = this.utilsService.getMainColor();
    const geofenceButtons = document.querySelectorAll('[id^="geofence-"]');
    geofenceButtons.forEach((button: any) => {
      if (this.geofencePanelVisible) {
        // Pannello aperto - bottone verde
        button.classList.remove('bg-white');
        button.style.backgroundColor = mainColor;
        const iconElement = button.querySelector('i');
        if (iconElement) {
          iconElement.className = 'fa-solid fa-map-location-dot text-gray-800 text-lg';
        }
      } else {
        // Pannello chiuso - bottone bianco
        button.classList.add('bg-white');
        button.style.backgroundColor = '#ffffff';
        const iconElement = button.querySelector('i');
        if (iconElement) {
          iconElement.className = 'fa-solid fa-location-dot text-gray-800 text-lg';
        }
      }
    });
  }

  /**
   * Carica e mostra i geofence sulla mappa
   */
  private loadAndShowGeofences(): void {
    if (this.selectedCustomerUidSelector$?.uid) {
      this.getGeofence();
    } else {
      console.warn('⚠️ Nessun customer selezionato per caricare i geofence');
    }
  }

  /**
   * Chiude il pannello geofence e nasconde i geofence dalla mappa
   */
  closeGeofencePanel(): void {
    this.geofencePanelVisible = false;
    this.geofenceActive = false;
    this.removeAllPolygonsGeofence();
    this.changeGeofence.next(false);
    this.geofencePanelToggle.next(false);
    this.updateGeofenceButtonState();
    console.log('❌ Geofence: Pannello chiuso e geofence nascosti');
  }

  removeAllPolygonsGeofence(): void {
    if (this.polygonsGeofence?.length > 0) {
      this.polygonsGeofence.forEach(polygon => {
        if (this.map) {
          this.map.removeLayer(polygon);
        }
      });
      this.polygonsGeofence = [];
    }
  }

  drawPolygonGeofence(row: any, editable: boolean, navigate: boolean = true, addTooltip: boolean = false): void {
    // Implementation for drawing geofence polygons with custom colors and names
    console.log('🗺️ Disegno poligono geofence:', row.name || row.uid);

    if (!this.map) {
      console.warn('❌ Mappa non inizializzata');
      return;
    }

    // Parse drawConf se è una stringa JSON
    let drawConf = row.drawConf;
    if (typeof drawConf === 'string') {
      try {
        drawConf = JSON.parse(drawConf);
        console.log('🔧 DrawConf parsato:', drawConf);
      } catch (e) {
        console.warn('⚠️ Errore parsing drawConf:', e);
        drawConf = { color: '#3388ff', mode: 'Polygon' };
      }
    }

    // Verifica che il geofence abbia geometria valida
    if (row && row.geometry && row.geometry.coordinates) {
      const coordinates = row.geometry.coordinates[0] || row.geometry.coordinates;
      const latlngs = coordinates.map((coord: any[]) => [coord[1], coord[0]]);

      // Determina il colore del poligono dal drawConf parsato
      const geofenceColor = drawConf?.color || '#3388ff';
      console.log('🎨 Colore utilizzato per il poligono:', geofenceColor, 'Mode:', drawConf?.mode);

      // Crea il poligono con gli stili personalizzati
      const polygonOptions: any = {
        color: geofenceColor,
        fillColor: geofenceColor,
        fillOpacity: 0.2,
        weight: 2,
        opacity: 0.8
      };

      // Aggiungi stili per la modalità editabile se necessario
      if (editable) {
        polygonOptions.weight = 3;
        polygonOptions.opacity = 1;
        polygonOptions.fillOpacity = 0.3;
      }

      const polygon = L.polygon(latlngs, polygonOptions);

      // Aggiungi sempre il tooltip con il nome del geofence
      if (row.name) {
        polygon.bindTooltip(row.name, {
          permanent: false,
          direction: 'center',
          className: 'geofence-tooltip',
          opacity: 0.9
        });

        // Mostra il tooltip al hover
        polygon.on('mouseover', function() {
          polygon.openTooltip();
        });

        polygon.on('mouseout', function() {
          polygon.closeTooltip();
        });
      }

      // Aggiungi il poligono alla mappa e alla lista
      polygon.addTo(this.map);
      this.polygonsGeofence.push(polygon);

      // Centra la mappa sul poligono se richiesto (ma non per tutti i geofence alla volta)
      if (navigate && latlngs.length > 0 && this.polygonsGeofence.length === 1) {
        this.map.fitBounds(polygon.getBounds(), {
          padding: [20, 20]
        });
      }

      // Emetti evento di cambiamento
      this.changeGeofenceLayer.next(polygon);

      console.log('✅ Poligono geofence disegnato:', row.name, 'con colore:', geofenceColor);
    } else {
      console.warn('⚠️ Geometria del geofence non valida:', row);
    }
  }

  drawShape(geofence: any, editable: boolean = true): void {
    console.log('🎨 Drawing geofence shape:', geofence);

    if (!this.map) {
      console.warn('Map not initialized');
      return;
    }

    if (!geofence?.geometry?.coordinates) {
      console.warn('❌ Geofence geometry not valid');
      return;
    }

    // Se è in modalità editable, utilizza il nuovo metodo di editing
    if (editable) {
      this.enableGeofenceEditing(geofence);
      return;
    } else {
      // Altrimenti usa il metodo normale
      this.drawPolygonGeofence(geofence, false, true, true);
    }
  }

  /**
   * Carica i geofence per il customer selezionato
   * Rimuove tutti i poligoni esistenti e carica i nuovi geofence dal server
   */
  getGeofence(): void {
    let self = this;

    // Rimuovi tutti i poligoni esistenti
    this.removeAllPolygonsGeofence();
    this.visibleGeofences = [];

    // Verifica che ci sia un customer selezionato
    if (!this.selectedCustomerUidSelector$ || !this.selectedCustomerUidSelector$.uid) {
      console.warn('❌ Nessun customer selezionato per il caricamento dei geofence');
      return;
    }

    console.log(`🔄 Caricamento geofence per customer: ${this.selectedCustomerUidSelector$.uid}`);

    // Chiamata API per ottenere i geofence
    this.apiService.get(GEOFENCING_BY_CUSTOMER_ENDPOINT + "/" + this.selectedCustomerUidSelector$.uid)
      .subscribe({
        next: (geofence: any) => {
          console.log(`✅ Caricati ${geofence?.length || 0} geofence`);

          self.visibleGeofences = geofence || [];

          // Processa ogni geofence caricato
          _.forEach(self.visibleGeofences, function (visibleGeofence) {
            // Assicurati che il geofence abbia un nome
            if (!visibleGeofence.name) {
              visibleGeofence.name = `Geofence ${visibleGeofence.uid?.substring(0, 8) || 'Senza nome'}`;
            }

            // Converte drawConf da stringa a oggetto se necessario PRIMA di disegnare
            if (typeof visibleGeofence.drawConf === 'string') {
              try {
                const parsedConf = JSON.parse(visibleGeofence.drawConf);
                visibleGeofence.drawConf = parsedConf;
                console.log('🎨 DrawConf parsato per geofence:', visibleGeofence.name, '- Colore:', parsedConf?.color, '- Mode:', parsedConf?.mode);
              } catch (e) {
                console.warn('⚠️ Errore parsing drawConf per geofence:', visibleGeofence.name, e);
                visibleGeofence.drawConf = { color: '#FF0000', mode: 'Polygon' }; // Default
              }
            }

            // Assicurati che drawConf esista con un colore di default se mancante
            if (!visibleGeofence.drawConf) {
              visibleGeofence.drawConf = { color: '#3388ff', mode: 'Polygon' };
              console.log('🎨 DrawConf creato per geofence:', visibleGeofence.name, 'colore di default:', visibleGeofence.drawConf.color);
            } else if (!visibleGeofence.drawConf.color) {
              visibleGeofence.drawConf.color = '#3388ff';
              console.log('🎨 Colore di default assegnato per geofence:', visibleGeofence.name, 'colore:', visibleGeofence.drawConf.color);
            }

            // Normalizza il mode se necessario
            if (visibleGeofence.drawConf.mode === 'Poly') {
              visibleGeofence.drawConf.mode = 'Polygon';
            }

            // Ora disegna il poligono sulla mappa con il colore e nome corretti
            self.drawPolygonGeofence(visibleGeofence, false, false, true);

            // Formatta gli schedule per la visualizzazione
            if (visibleGeofence.schedule) {
              visibleGeofence.formattedSchedules = self.formatSchedules(visibleGeofence);
            }
          });

          // Emetti il cambiamento per notificare altri componenti
          self.changeGeofence.next(true);
        },
        error: (error) => {
          console.error('❌ Errore nel caricamento dei geofence:', error);
          self.visibleGeofences = [];

          // Non mostrare errore se è un 404 (nessun geofence trovato)
          if (error.status !== 404) {
            // Qui potresti mostrare un messaggio di errore all'utente
            console.error('Errore nel caricamento dei geofence:', error);
          }
        }
      });
  }

  /**
   * Formatta gli schedule dei geofence per la visualizzazione
   * @param geofence Il geofence con gli schedule da formattare
   * @returns Array di stringhe formattate che descrivono gli schedule
   */
  formatSchedules(geofence: any): string[] {
    if (!geofence.schedule || geofence.schedule.length === 0) {
      return [];
    }

    return geofence.schedule.map((schedule: any) => {
      if (schedule.type === 'Once') {
        const startDate = new Date(schedule.timestampStart).toLocaleDateString('it-IT');
        const endDate = new Date(schedule.timestampEnd).toLocaleDateString('it-IT');
        return `Una volta: ${startDate} - ${endDate}`;
      } else if (schedule.type === 'Weekly') {
        const dayNames = ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'];
        const dayName = dayNames[schedule.dayOfWeek] || 'N/A';
        const startTime = new Date(schedule.timestampStart).toLocaleTimeString('it-IT', {
          hour: '2-digit',
          minute: '2-digit'
        });
        const endTime = new Date(schedule.timestampEnd).toLocaleTimeString('it-IT', {
          hour: '2-digit',
          minute: '2-digit'
        });
        return `${dayName}: ${startTime} - ${endTime}`;
      } else if (schedule.type === 'Daily') {
        const startTime = new Date(schedule.timestampStart).toLocaleTimeString('it-IT', {
          hour: '2-digit',
          minute: '2-digit'
        });
        const endTime = new Date(schedule.timestampEnd).toLocaleTimeString('it-IT', {
          hour: '2-digit',
          minute: '2-digit'
        });
        return `Giornaliero: ${startTime} - ${endTime}`;
      }
      return 'Schedule non riconosciuto';
    });
  }

  /**
   * Rimuove tutti i poligoni dei geofence dalla mappa
   * Compatibile con il metodo esistente
   */
  removeAllPolygons(): void {
    this.removeAllPolygonsGeofence();
  }

  /**
   * Disegna un poligono sulla mappa (alias per drawPolygonGeofence)
   * @param geofence Il geofence da disegnare
   * @param editable Se il poligono deve essere editabile
   */
  drawPolygon(geofence: any, editable: boolean): void {
    this.drawPolygonGeofence(geofence, editable, true, true);
  }

  /**
   * Abilita l'editing di un poligono geofence esistente
   * @param geofence Il geofence da rendere editabile
   * @returns Il layer del poligono editabile
   */
  enableGeofenceEditing(geofence: any): L.Polygon | null {
    if (!this.map || !geofence?.geometry?.coordinates) {
      console.warn('❌ Mappa non inizializzata o geometria del geofence non valida');
      return null;
    }

    console.log('✏️ Abilitazione editing per geofence:', geofence.name);

    // Rimuovi tutti i poligoni esistenti
    this.removeAllPolygonsGeofence();

    // Ridisegna tutti i geofence non in editing
    this.visibleGeofences.forEach(g => {
      if (g.uid !== geofence.uid) {
        this.drawPolygonGeofence(g, false, false, true);
      }
    });

    // Crea il poligono editabile per il geofence selezionato
    const coordinates = geofence.geometry.coordinates[0] || geofence.geometry.coordinates;
    const latlngs = coordinates.map((coord: any[]) => [coord[1], coord[0]]);

    // Determina il colore dal drawConf
    let drawConf = geofence.drawConf;
    if (typeof drawConf === 'string') {
      try {
        drawConf = JSON.parse(drawConf);
      } catch (e) {
        drawConf = { color: '#3388ff', mode: 'Polygon' };
      }
    }

    const geofenceColor = drawConf?.color || '#3388ff';

    // Crea il poligono con stili per l'editing
    const editablePolygon = L.polygon(latlngs, {
      color: geofenceColor,
      fillColor: geofenceColor,
      fillOpacity: 0.3,
      weight: 3,
      opacity: 1,
      // Stili per indicare che è editabile
      dashArray: '5, 5'
    });

    // Aggiungi tooltip permanente per indicare modalità edit
    editablePolygon.bindTooltip(`📝 ${geofence.name} (Modalità Edit)`, {
      permanent: true,
      direction: 'center',
      className: 'geofence-edit-tooltip'
    });

    // Aggiungi al layer group editabile PRIMA di aggiungerlo alla mappa
    // Questo permette a leaflet-draw di gestire l'editing automaticamente
    this.editableLayers.addLayer(editablePolygon);
    this.polygonsGeofence.push(editablePolygon);

    console.log('✅ Poligono aggiunto al layer editabile, ora modificabile tramite leaflet-draw');

    // Attiva automaticamente la modalità di editing tramite simulazione click
    // Questo mostrerà i punti di controllo per modificare il poligono
    setTimeout(() => {
      try {
        // Cerca il bottone di editing nella toolbar di leaflet-draw
        const editButton = document.querySelector('.leaflet-draw-edit-edit') as HTMLElement;
        if (editButton && !editButton.classList.contains('leaflet-draw-toolbar-button-enabled')) {
          editButton.click();
          console.log('🎯 Modalità editing attivata tramite click simulato - ora visibili i punti di controllo');
        } else {
          console.log('🔍 Bottone editing non trovato o già attivo');
        }
      } catch (error) {
        console.warn('⚠️ Errore nell\'attivazione automatica del modo editing:', error);
      }
    }, 200);

    // Centra la mappa sul poligono
    this.map.fitBounds(editablePolygon.getBounds(), {
      padding: [20, 20]
    });

    console.log('✅ Editing abilitato per geofence:', geofence.name);
    return editablePolygon;
  }

  /**
   * Disabilita l'editing e ritorna alla visualizzazione normale
   */
  disableGeofenceEditing(): void {
    console.log('❌ Disabilitazione modalità editing geofence');

    // Disattiva la modalità editing se attiva
    try {
      const editButton = document.querySelector('.leaflet-draw-edit-edit') as HTMLElement;
      if (editButton && editButton.classList.contains('leaflet-draw-toolbar-button-enabled')) {
        editButton.click();
        console.log('✅ Modalità editing disattivata tramite click simulato');
      }
    } catch (error) {
      console.warn('⚠️ Errore nella disattivazione del modo editing:', error);
    }

    // Pulisci i layer editabili
    if (this.editableLayers) {
      this.editableLayers.clearLayers();
    }

    // Rimuovi tutti i poligoni
    this.removeAllPolygonsGeofence();

    // Ridisegna tutti i geofence in modalità normale
    this.visibleGeofences.forEach(geofence => {
      this.drawPolygonGeofence(geofence, false, false, true);
    });

    console.log('✅ Modalità editing disabilitata');
  }
}
